const QUIZAPP_URL = "https://feedingplan.supremesourcepet.com";

const FEEDING_PLAN_SLIDER_VALUES = [
  "all_kibble",
  "mostly_kibble",
  "mostly_canned",
  "all_canned",
];

function mapSliderIndexToFeedingPlan(index) {
  var normalizedIndex = Math.max(
    0,
    Math.min(FEEDING_PLAN_SLIDER_VALUES.length - 1, Number(index) || 0),
  );
  return FEEDING_PLAN_SLIDER_VALUES[normalizedIndex];
}

function mapFeedingPlanToSliderIndex(feedingPlan) {
  var valueToIndex = {
    all_kibble: 0,
    dry_only: 0,
    mostly_kibble: 1,
    half_half: 1,
    mostly_canned: 2,
    all_canned: 3,
    wet_only: 3,
  };

  return Object.prototype.hasOwnProperty.call(valueToIndex, feedingPlan)
    ? valueToIndex[feedingPlan]
    : 0;
}

function renderFeedingPlanVisualState() {
  var feedingPlanControl = document.getElementById("feeding-plan-control");
  var feedingPlanSlider = document.getElementById("feeding-plan-slider");
  var feedingPlanNotSure = document.getElementById("feeding-plan-not-sure");

  if (!feedingPlanControl || !feedingPlanSlider) return;

  var sliderMax = Number(feedingPlanSlider.max) || 3;
  var sliderValue = Number(feedingPlanSlider.value) || 0;
  var progressPct = sliderMax > 0 ? (sliderValue / sliderMax) * 100 : 0;

  feedingPlanControl.style.setProperty(
    "--feeding-plan-progress",
    progressPct + "%",
  );

  var labels = feedingPlanControl.querySelectorAll(
    ".quiz-feeding-plan__labels span",
  );

  labels.forEach(function (label, idx) {
    label.classList.toggle("is-active", idx === sliderValue);
  });

  feedingPlanControl.classList.toggle(
    "is-not-sure",
    Boolean(feedingPlanNotSure && feedingPlanNotSure.checked),
  );
}

document.addEventListener("DOMContentLoaded", function () {
  initializePetDetails();
  fillDataFromLocalStorage();

  var summaryToggle = document.getElementById("results-summary-toggle");
  var summaryPanel = document.getElementById("results-summary-panel");

  function setSummaryExpanded(isExpanded) {
    if (!summaryToggle || !summaryPanel) return;
    summaryToggle.setAttribute("aria-expanded", String(isExpanded));
    summaryToggle.classList.toggle("is-open", isExpanded);
    summaryPanel.classList.toggle("is-open", isExpanded);
  }

  if (summaryToggle && summaryPanel) {
    setSummaryExpanded(false);
    summaryToggle.addEventListener("click", function () {
      var isExpanded = summaryToggle.getAttribute("aria-expanded") === "true";
      setSummaryExpanded(!isExpanded);
    });
  }

  // Screen 1
  let nameInput = document.getElementById("fname");
  let continueBtn1 = document.getElementById("continue-button");

  if (nameInput && continueBtn1) {
    nameInput.addEventListener("input", function () {
      continueBtn1.disabled = nameInput.value.trim() === "";
    });

    nameInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && nameInput.value.trim() !== "") {
        continueBtn1.click();
      }
    });

    continueBtn1.addEventListener("click", function () {
      if (nameInput.checkValidity()) {
        setPetDetails("name", nameInput.value.trim());
        showpage(2);
      } else {
        nameInput.reportValidity();
      }
    });
  }

  // Screen 2
  let emailInput = document.getElementById("email");
  let continueBtn2 = document.getElementById("continue-button-1");
  let backBtn1 = document.getElementById("back-button-1");

  if (emailInput && continueBtn2 && backBtn1) {
    emailInput.addEventListener("input", function () {
      let email = emailInput.value.trim();
      continueBtn2.disabled = email === "";
    });

    emailInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && emailInput.value.trim() !== "") {
        continueBtn2.click();
      }
    });

    continueBtn2.addEventListener("click", function () {
      if (emailInput.checkValidity()) {
        setPetDetails("email", emailInput.value.trim());
        klaviyoStartQuiz();
        showpage(3);
      } else {
        emailInput.reportValidity();
      }
    });

    backBtn1.addEventListener("click", function () {
      showpage(1);
    });
  }

  // Screen 3
  let petAgeSelect = document.getElementById("pet-age");
  let continueBtn3 = document.getElementById("continue-button-2");
  let backBtn2 = document.getElementById("back-button-2");

  if (petAgeSelect && continueBtn3 && backBtn2) {
    petAgeSelect.addEventListener("change", function () {
      continueBtn3.disabled = petAgeSelect.value === "0";
    });

    continueBtn3.addEventListener("click", function () {
      // setPetDetails("age", petAgeSelect.value);
      setPetDetails("dob", petAgeSelect.value);
      showpage(4);
    });

    backBtn2.addEventListener("click", function () {
      showpage(2);
    });
  }

  // Screen 4 - Spayed/Neutered
  let spayedRadios = document.querySelectorAll('input[name="spayed-neutered"]');
  let continueBtn4 = document.getElementById("continue-button-3");
  let backBtn3 = document.getElementById("back-button-3");

  spayedRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      continueBtn4.disabled = false;
    });
  });

  if (continueBtn4 && backBtn3) {
    continueBtn4.addEventListener("click", function () {
      var selected = document.querySelector(
        'input[name="spayed-neutered"]:checked',
      );
      setPetDetails("spayed", selected ? selected.value : "");
      showpage(6);
      populateBreedsDropdown();
    });
    backBtn3.addEventListener("click", function () {
      showpage(3);
    });
  }

  // Screen 5 - Weight (now comes after Breed)
  let weightInput = document.getElementById("weight");
  let continueBtn5 = document.getElementById("continue-button-4");
  let backBtn4 = document.getElementById("back-button-4");

  if (weightInput && continueBtn5 && backBtn4) {
    weightInput.addEventListener("input", function () {
      continueBtn5.disabled = weightInput.value.trim() === "";
    });

    weightInput.addEventListener("keydown", function (event) {
      if (event.key === "Enter" && weightInput.value.trim() !== "") {
        continueBtn5.click();
      }
    });

    continueBtn5.addEventListener("click", function () {
      setPetDetails("weight", weightInput.value.trim());
      showpage(7);
    });

    backBtn4.addEventListener("click", function () {
      showpage(6);
    });
  }

  // Screen 6 - Breed (now comes before Weight)
  let continueBtn6 = document.getElementById("continue-button-5");
  let backBtn5 = document.getElementById("back-button-5");
  let addBreedBtn = document.getElementById("add-breed-btn");
  let removeBreedBtn = document.getElementById("remove-breed-btn");
  let secondBreedContainer = document.getElementById("second-breed-container");
  let addBreedText = document.getElementById("add-breed-text");

  function swapBreedImage(mode) {
    var breedImgs = document.querySelectorAll(
      "#quiz-page-6 .quiz-screen__dynamic-img",
    );
    breedImgs.forEach(function (img) {
      img.classList.toggle("active", img.getAttribute("data-breed") === mode);
    });
  }

  if (addBreedBtn) {
    addBreedBtn.addEventListener("click", function () {
      if (secondBreedContainer) secondBreedContainer.style.display = "block";
      if (addBreedText) addBreedText.style.display = "none";
      swapBreedImage("mixed");
    });
  }

  if (removeBreedBtn) {
    removeBreedBtn.addEventListener("click", function () {
      if (secondBreedContainer) secondBreedContainer.style.display = "none";
      if (addBreedText) addBreedText.style.display = "block";
      var breed2El = document.getElementById("selectedBreed2");
      if (breed2El) breed2El.textContent = "Second Breed";
      swapBreedImage("single");
    });
  }

  if (continueBtn6 && backBtn5) {
    continueBtn6.addEventListener("click", function () {
      var breed1El = document.getElementById("selectedBreed");
      var breed1 = breed1El ? breed1El.textContent.trim() : "";
      var breedValue = breed1;
      if (
        secondBreedContainer &&
        secondBreedContainer.style.display !== "none"
      ) {
        var breed2El = document.getElementById("selectedBreed2");
        if (breed2El) {
          var breed2 = breed2El.textContent.trim();
          if (breed2 && breed2 !== "Second Breed") {
            breedValue = breed1 + ", " + breed2;
          }
        }
      }
      setPetDetails("breed", breedValue);
      showpage(5);
    });

    backBtn5.addEventListener("click", function () {
      showpage(4);
    });
  }

  // Screen 7 - Activity Level (radio)
  let activityOptions = document.querySelectorAll(
    'input[name="activity-level"]',
  );
  let continueBtn7 = document.getElementById("continue-button-6");
  let backBtn6 = document.getElementById("back-button-6");
  let activityHelper = document.getElementById("activity-helper");

  if (activityOptions.length) {
    activityOptions.forEach(function (option) {
      option.addEventListener("change", function () {
        var selectedValue = this.value;
        var selectedDesc = this.dataset.desc || "";

        var images = document.querySelectorAll(
          "#quiz-page-7 .quiz-screen__dynamic-img",
        );
        images.forEach(function (img) {
          if (img.dataset.activity === selectedValue) {
            img.classList.add("active");
          } else {
            img.classList.remove("active");
          }
        });

        if (activityHelper) {
          activityHelper.textContent = selectedDesc;
        }
        if (continueBtn7) continueBtn7.disabled = false;
      });
    });
  }

  if (continueBtn7 && backBtn6) {
    continueBtn7.addEventListener("click", function () {
      var selectedActivity = document.querySelector(
        'input[name="activity-level"]:checked',
      );
      setPetDetails("activity", selectedActivity ? selectedActivity.value : "");
      showpage(8);
    });
    backBtn6.addEventListener("click", function () {
      showpage(5);
    });
  }

  // Screen 8 - Body Type (radio)
  let bodyOptions = document.querySelectorAll('input[name="body-type"]');
  let continueBtn8 = document.getElementById("continue-button-7");
  let backBtn7 = document.getElementById("back-button-7");
  let bodyHelper = document.getElementById("bodytype-helper");

  if (bodyOptions.length) {
    bodyOptions.forEach(function (option) {
      option.addEventListener("change", function () {
        var selectedValue = this.value;
        var selectedDesc = this.dataset.desc || "";

        var images = document.querySelectorAll(
          "#quiz-page-8 .quiz-screen__dynamic-img",
        );
        images.forEach(function (img) {
          if (img.dataset.body === selectedValue) {
            img.classList.add("active");
          } else {
            img.classList.remove("active");
          }
        });

        if (bodyHelper) {
          bodyHelper.textContent = selectedDesc;
        }
        if (continueBtn8) continueBtn8.disabled = false;
      });
    });
  }

  if (continueBtn8 && backBtn7) {
    continueBtn8.addEventListener("click", function () {
      var selectedBodyType = document.querySelector(
        'input[name="body-type"]:checked',
      );
      setPetDetails("bodytype", selectedBodyType ? selectedBodyType.value : "");
      showpage(9);
    });
    backBtn7.addEventListener("click", function () {
      showpage(7);
    });
  }

  // Utility function for "other" option handling
  function unCheckOtherOption(input, label, block) {
    if (input && label && block) {
      input.style.display = "none";
      label.style.display = "inline-flex";
      block.classList.remove("active");
    }
  }

  function setupCheckboxScreen(config) {
    var inputSelector = config.inputSelector;
    var continueBtnId = config.continueBtnId;
    var backBtnId = config.backBtnId;
    var otherInputId = config.otherInputId;
    var otherLabelId = config.otherLabelId;
    var otherBlockId = config.otherBlockId;
    var noOptionText = config.noOptionText;
    var detailKey = config.detailKey;
    var nextPage = config.nextPage;
    var prevPage = config.prevPage;

    var inputs = document.querySelectorAll(inputSelector);
    var continueBtn = document.getElementById(continueBtnId);
    var backBtn = document.getElementById(backBtnId);
    var otherInput = otherInputId
      ? document.getElementById(otherInputId)
      : null;
    var otherLabel = otherLabelId
      ? document.getElementById(otherLabelId)
      : null;
    var otherBlock = otherBlockId
      ? document.getElementById(otherBlockId)
      : null;

    // Helper to validate if form is complete
    function validateForm() {
      var hasChecked = Array.from(inputs).some(function (el) {
        return el.checked;
      });
      if (!hasChecked) return false;

      // If "other" is checked, ensure text input has value
      var otherChecked = Array.from(inputs).some(function (el) {
        return el.checked && el.value === "other";
      });
      if (otherChecked && otherInput) {
        return otherInput.value.trim() !== "";
      }

      return true;
    }

    // Update continue button state
    function updateContinueButton() {
      if (continueBtn) continueBtn.disabled = !validateForm();
    }

    inputs.forEach(function (input, i) {
      input.addEventListener("change", function () {
        var val = input.value.toLowerCase();
        var isNoOption = val.includes(noOptionText);
        var isOther = val === "other";

        if (isNoOption && input.checked) {
          inputs.forEach(function (el, j) {
            if (j !== i) el.checked = false;
            if (otherInput)
              unCheckOtherOption(otherInput, otherLabel, otherBlock);
          });
        }
        if (!isNoOption && input.checked) {
          inputs.forEach(function (el) {
            if (el.value.toLowerCase().includes(noOptionText))
              el.checked = false;
          });
        }
        if (isOther) {
          if (input.checked) {
            if (otherInput) {
              otherInput.style.display = "inline-flex";
              otherLabel.style.display = "none";
              otherBlock.classList.add("active");
              otherInput.focus();
            }
          } else if (otherInput) {
            unCheckOtherOption(otherInput, otherLabel, otherBlock);
          }
        }
        updateContinueButton();
      });
    });

    // Listen to otherInput changes
    if (otherInput) {
      otherInput.addEventListener("input", function () {
        updateContinueButton();
      });
    }

    if (continueBtn && backBtn) {
      continueBtn.addEventListener("click", function () {
        var selected = Array.from(inputs)
          .filter(function (el) {
            return el.checked;
          })
          .map(function (el) {
            return el.value;
          });
        var otherKey =
          detailKey === "healthIssues"
            ? "customHealthIssue"
            : "customAllergyIssue";
        if (selected.includes("other") && otherInput) {
          setPetDetails(otherKey, otherInput.value.trim());
        } else {
          // Prevent stale custom text from previous runs when "other" is unchecked.
          setPetDetails(otherKey, "");
        }
        setPetDetails(detailKey, selected);
        showpage(nextPage);
      });

      backBtn.addEventListener("click", function () {
        showpage(prevPage);
      });
    }
  }

  // Screen 9 - Health Issues
  setupCheckboxScreen({
    inputSelector: "#quiz-page-9 .health-issues",
    continueBtnId: "continue-button-8",
    backBtnId: "back-button-8",
    otherInputId: "other-input",
    otherLabelId: "other-label",
    otherBlockId: "other-option-block",
    noOptionText: "none",
    detailKey: "healthIssues",
    nextPage: 10,
    prevPage: 8,
  });

  // Screen 10 - Food Allergies
  setupCheckboxScreen({
    inputSelector: "#quiz-page-10 .food-allergies",
    continueBtnId: "continue-button-9",
    backBtnId: "back-button-9",
    otherInputId: "other-input-9",
    otherLabelId: "other-label-9",
    otherBlockId: "other-option-block-9",
    noOptionText: "none",
    detailKey: "allergies",
    nextPage: 11,
    prevPage: 9,
  });

  // Screen 11 - Feeding Plan
  let feedingPlanSlider = document.getElementById("feeding-plan-slider");
  let feedingPlanNotSure = document.getElementById("feeding-plan-not-sure");
  let feedingPlanControl = document.getElementById("feeding-plan-control");
  let continueBtnFP = document.getElementById("continue-button-10");
  let backBtnFP = document.getElementById("back-button-10");

  if (feedingPlanSlider && feedingPlanNotSure && continueBtnFP && backBtnFP) {
    var hasSliderSelection = true;

    var updateFeedingPlanControlState = function () {
      var isNotSureChecked = feedingPlanNotSure.checked;
      feedingPlanSlider.disabled = isNotSureChecked;
      if (feedingPlanControl) {
        feedingPlanControl.classList.toggle("is-disabled", isNotSureChecked);
      }
      continueBtnFP.disabled = !isNotSureChecked && !hasSliderSelection;
      renderFeedingPlanVisualState();
    };

    feedingPlanSlider.addEventListener("input", function () {
      hasSliderSelection = true;
      updateFeedingPlanControlState();
    });

    feedingPlanNotSure.addEventListener("change", function () {
      updateFeedingPlanControlState();
    });

    continueBtnFP.addEventListener("click", function () {
      var selectedFeedingPlan = feedingPlanNotSure.checked
        ? "Not sure"
        : mapSliderIndexToFeedingPlan(feedingPlanSlider.value);

      setPetDetails("feedingPlan", selectedFeedingPlan);
      submitDetails();
    });

    backBtnFP.addEventListener("click", function () {
      showpage(10);
    });

    updateFeedingPlanControlState();
  }
});
function initializePetDetails() {
  if (!localStorage.getItem("petDetails")) {
    const initialDetails = {
      name: "",
      email: "",
      dob: "",
      spayed: "",
      weight: "",
      breed: "",
      activity: "",
      bodytype: "",
      healthIssues: [],
      allergies: [],
      customHealthIssue: "",
      customAllergyIssue: "",
      feedingPlan: "",
    };
    localStorage.setItem("petDetails", JSON.stringify(initialDetails));
  }
}
function fillDataFromLocalStorage() {
  var petDetails = getPetDetails();

  // Screen 1
  var nameInput = document.getElementById("fname");
  if (nameInput && petDetails && petDetails.name) {
    nameInput.value = petDetails.name;
    var cb = document.getElementById("continue-button");
    if (cb) cb.disabled = petDetails.name.trim() === "";
  }

  // Screen 2
  var emailInput = document.getElementById("email");
  if (emailInput && petDetails && petDetails.email) {
    emailInput.value = petDetails.email;
    var cb2 = document.getElementById("continue-button-1");
    if (cb2) cb2.disabled = petDetails.email.trim() === "";
  }

  // Screen 3
  var petAgeSelect = document.getElementById("pet-age");
  if (petAgeSelect && petDetails && petDetails.dob) {
    petAgeSelect.value = petDetails.dob;
    var cb3 = document.getElementById("continue-button-2");
    if (cb3) cb3.disabled = petAgeSelect.value === "0";
  }

  // Screen 4 - Spayed/Neutered
  var spayedRadios = document.querySelectorAll('input[name="spayed-neutered"]');
  if (spayedRadios.length && petDetails && petDetails.spayed) {
    spayedRadios.forEach(function (radio) {
      if (radio.value === petDetails.spayed) radio.checked = true;
    });
    var cb4 = document.getElementById("continue-button-3");
    if (cb4) cb4.disabled = false;
  }

  // Screen 6 - Breed (now comes before Weight)
  var selectedBreed = document.getElementById("selectedBreed");
  if (selectedBreed && petDetails && petDetails.breed) {
    var breeds = petDetails.breed.split(", ");
    selectedBreed.textContent = breeds[0];
    if (breeds[1]) {
      var breed2El = document.getElementById("selectedBreed2");
      if (breed2El) breed2El.textContent = breeds[1];
      var secondContainer = document.getElementById("second-breed-container");
      var addText = document.getElementById("add-breed-text");
      if (secondContainer) secondContainer.style.display = "block";
      if (addText) addText.style.display = "none";
      // Swap to mixed breed image
      var breedImgs = document.querySelectorAll(
        "#quiz-page-6 .quiz-screen__dynamic-img",
      );
      breedImgs.forEach(function (img) {
        img.classList.toggle(
          "active",
          img.getAttribute("data-breed") === "mixed",
        );
      });
    }
    var cb6 = document.getElementById("continue-button-5");
    if (cb6) cb6.disabled = false;
  }

  // Screen 5 - Weight (now comes after Breed)
  var weightInput = document.getElementById("weight");
  if (weightInput && petDetails && petDetails.weight) {
    weightInput.value = petDetails.weight;
    var cb5 = document.getElementById("continue-button-4");
    if (cb5) cb5.disabled = String(petDetails.weight).trim() === "";
  }

  // Screen 7 - Activity
  var activityOptions = document.querySelectorAll(
    'input[name="activity-level"]',
  );
  if (activityOptions.length && petDetails && petDetails.activity) {
    activityOptions.forEach(function (input) {
      input.checked = input.value === petDetails.activity;
    });
    var actImgs = document.querySelectorAll(
      "#quiz-page-7 .quiz-screen__dynamic-img",
    );
    actImgs.forEach(function (img) {
      img.classList.toggle(
        "active",
        img.dataset.activity === petDetails.activity,
      );
    });
    var selectedActivity = document.querySelector(
      'input[name="activity-level"]:checked',
    );
    var actHelper = document.getElementById("activity-helper");
    if (actHelper && selectedActivity) {
      actHelper.textContent = selectedActivity.dataset.desc || "";
    }
    var cb7 = document.getElementById("continue-button-6");
    if (cb7) cb7.disabled = false;
  }

  // Screen 8 - Body Type
  var bodyOptions = document.querySelectorAll('input[name="body-type"]');
  if (bodyOptions.length && petDetails && petDetails.bodytype) {
    bodyOptions.forEach(function (input) {
      input.checked = input.value === petDetails.bodytype;
    });
    var bodyImgs = document.querySelectorAll(
      "#quiz-page-8 .quiz-screen__dynamic-img",
    );
    bodyImgs.forEach(function (img) {
      img.classList.toggle("active", img.dataset.body === petDetails.bodytype);
    });
    var selectedBody = document.querySelector(
      'input[name="body-type"]:checked',
    );
    var bHelper = document.getElementById("bodytype-helper");
    if (bHelper && selectedBody)
      bHelper.textContent = selectedBody.dataset.desc || "";
    var cb8 = document.getElementById("continue-button-7");
    if (cb8) cb8.disabled = false;
  }

  // Screen 9 - Health
  var healthInputs = document.querySelectorAll("#quiz-page-9 .health-issues");
  if (
    healthInputs.length &&
    petDetails &&
    petDetails.healthIssues &&
    petDetails.healthIssues.length
  ) {
    healthInputs.forEach(function (input) {
      input.checked = petDetails.healthIssues.includes(input.value);
    });

    var otherInput9 = null;
    if (
      petDetails.healthIssues.includes("other") &&
      petDetails.customHealthIssue
    ) {
      var oi = document.getElementById("other-input");
      var ol = document.getElementById("other-label");
      var ob = document.getElementById("other-option-block");
      if (oi) {
        oi.value = petDetails.customHealthIssue;
        oi.style.display = "inline-flex";
        if (ol) ol.style.display = "none";
        if (ob) ob.classList.add("active");
        otherInput9 = oi;
      }
    }

    // Validate continue button with proper "other" check
    var cb9 = document.getElementById("continue-button-8");
    if (cb9) {
      var hasChecked = Array.from(healthInputs).some(function (el) {
        return el.checked;
      });
      var otherChecked = petDetails.healthIssues.includes("other");
      var otherHasValue = otherInput9 && otherInput9.value.trim() !== "";
      cb9.disabled = !hasChecked || (otherChecked && !otherHasValue);
    }
  }

  // Screen 10 - Food Allergies
  var allergyInputs = document.querySelectorAll(
    "#quiz-page-10 .food-allergies",
  );
  if (
    allergyInputs.length &&
    petDetails &&
    petDetails.allergies &&
    petDetails.allergies.length
  ) {
    allergyInputs.forEach(function (input) {
      input.checked = petDetails.allergies.includes(input.value);
    });

    var otherInput10 = null;
    if (
      petDetails.allergies.includes("other") &&
      petDetails.customAllergyIssue
    ) {
      var oi9 = document.getElementById("other-input-9");
      var ol9 = document.getElementById("other-label-9");
      var ob9 = document.getElementById("other-option-block-9");
      if (oi9) {
        oi9.value = petDetails.customAllergyIssue;
        oi9.style.display = "inline-flex";
        if (ol9) ol9.style.display = "none";
        if (ob9) ob9.classList.add("active");
        otherInput10 = oi9;
      }
    }

    // Validate continue button with proper "other" check
    var cb10 = document.getElementById("continue-button-9");
    if (cb10) {
      var hasChecked = Array.from(allergyInputs).some(function (el) {
        return el.checked;
      });
      var otherChecked = petDetails.allergies.includes("other");
      var otherHasValue = otherInput10 && otherInput10.value.trim() !== "";
      cb10.disabled = !hasChecked || (otherChecked && !otherHasValue);
    }
  }

  // Screen 11 - Feeding Plan
  var feedingPlanSlider = document.getElementById("feeding-plan-slider");
  var feedingPlanNotSure = document.getElementById("feeding-plan-not-sure");
  var feedingPlanControl = document.getElementById("feeding-plan-control");
  var cb11 = document.getElementById("continue-button-10");

  if (feedingPlanSlider && feedingPlanNotSure) {
    if (petDetails && petDetails.feedingPlan) {
      if (petDetails.feedingPlan === "Not sure") {
        feedingPlanNotSure.checked = true;
      } else {
        feedingPlanSlider.value = mapFeedingPlanToSliderIndex(
          petDetails.feedingPlan,
        );
        feedingPlanNotSure.checked = false;
      }

      if (cb11) cb11.disabled = false;
    }

    feedingPlanSlider.disabled = feedingPlanNotSure.checked;
    if (feedingPlanControl) {
      feedingPlanControl.classList.toggle(
        "is-disabled",
        feedingPlanNotSure.checked,
      );
    }

    renderFeedingPlanVisualState();
  }
}

function populateBreedsDropdown() {
  const breedsList = [
    "Abruzzenhund",
    "Adronicus Mastiff",
    "Afador",
    "Afaird",
    "Affen Spaniel",
    "Affen Border Terrier",
    "Affen Tzu",
    "Affenchon",
    "Affengriffon",
    "Affenhuahua",
    "Affenpinscher",
    "Affenpoo",
    "Affenpug",
    "Affenshire",
    "Affenwich",
    "Afghan Chon",
    "Afghan Collie",
    "Afghan Gaddi",
    "Afghan Hound",
    "Afghan Retriever",
    "Afghan Sheepdog",
    "Afghan Spaniel",
    "African-American Bull Boerboel",
    "African Pitbull",
    "Afollie",
    "African Wild Dog",
    "Africanis",
    "Aidi",
    "Ainu Dog",
    "Airedale Shepherd",
    "Airedale Terrier",
    "Airedoodle",
    "Akbash Dog",
    "Akbash Pyrenees",
    "Akbash Rottie",
    "Aki-Poo",
    "Akitas",
    "Akita (American)",
    "Akita Basset",
    "Akita Bernard",
    "Akita Chow",
    "Akita Inu (Japanese)",
    "Akita Pit",
    "Akita Shepherd",
    "Akitamatian",
    "Alaknoori ",
    "Alano Español",
    "Alapaha Blue Blood Bulldog",
    "Alaskan Goldenmute",
    "Alaskan Husky",
    "Alaskan Husky Shepherd",
    "Alaskan Irish Setsky",
    "Alaskan Klee Kai",
    "Alaskan Malador",
    "Alaskan Malamute",
    "Alaskan Noble Companion Dog ",
    "Alaskan Shepherd",
    "Alaskan Weimsky",
    "Alaunt",
    "Alopekis",
    "Alp Mastiff (Cane Garouf)",
    "Alpine Dachsbracke",
    "Alpine Mastiff",
    "Alpine Spaniel",
    "Alusky",
    "Ambullneo Mastiff",
    "Ameri-Indian Husky",
    "American Alsatian",
    "American Allaunt",
    "American Bandogge Mastiff",
    "American Black and Tan Coonhound",
    "American Blue Gascon Hound",
    "American Blue Lacy",
    "American Boston Bull Terrier",
    "American Boxer Foxhound",
    "American Bull Dane",
    "American Bull Dogue de Bordeaux",
    "American Bull Mastiff",
    "American Bull Molosser",
    "American Bull Pei",
    "American Bull Staffy",
    "American Bullador",
    "American Bull-Aussie",
    "American Bulldog",
    "American Bulldog Shepherd",
    "American Bullhuahua",
    "American Bullnese",
    "American Bullweiler",
    "American Bully",
    "American Cocker Chow",
    "American Cocker Spaniel",
    "American Crested Sand Terrier ",
    "American Eagle Dog",
    "American English Coonhound",
    "American Eskimo Dog",
    "American Foxeagle",
    "American Foxhound",
    "American French Bull Terrier",
    "American French Bulldog",
    "American Gointer",
    "American Hairless Min Pin",
    "American Hairless Terrier",
    "American Hunt Terrier ",
    "American Indian Dog",
    "American Lab Foxhound",
    "American Leopard Hound",
    "American Lo-Sze Pugg™",
    "American Mastiff",
    "American Mastiff (Panja)",
    "American Neo Bull",
    "American Pit Bull Terrier",
    "American Pit Corso",
    "American Pugabull",
    "American Rat Pinscher",
    "American Staffordshire Bully",
    "American Staffordshire Terrier",
    "American Staffy Bullmastiff",
    "American Staghound",
    "American Toy Terrier",
    "American Treeing Feist",
    "American Tundra Shepherd Dog ",
    "American Water Spaniel",
    "American White Shepherd",
    "Amitola Bulldog",
    "Amstiff",
    "Anangu",
    "Anatolian Pyrenees",
    "Anatolian Shepherd Dog",
    "Andalusian Podenco",
    "Anglo-Françai Grand ",
    "Anglo-Français de Moyenne Venerie ",
    "Anglo-Françaises ",
    "Anglo-Françaises de Petite Venerie ",
    "Antebellum Bulldog",
    "Appenzell Mountain Dog",
    "Argentine Dogo",
    "Ariege Pointing Dog ",
    "Ariegeois",
    "Armant ",
    "Armenian Gampr",
    "Arubian Cunucu Dog",
    "Aryan Molossus ",
    "Aspin",
    "Atlas Terrier",
    "Ausahoula",
    "Ausky",
    "Aussalier",
    "Aussie Brittany",
    "Aussie Bulldog",
    "Aussie-Chi",
    "Aussie Collie",
    "Aussie-Corgi",
    "Aussiedoodle",
    "Aussiedor",
    "Aussie-Flat",
    "Aussie Jack",
    "Aussie Malamute",
    "Aussie Newfie",
    "Aussie Rottie",
    "Aussie Shiba",
    "Aussie Siberian",
    "Aussie Springer",
    "Auss-Tzu",
    "Austi-Pap",
    "Australian Bandog",
    "Australian Boxherd",
    "Australian Bulldog",
    "Australian Cattle Dog",
    "Australian Cobberdog",
    "Australian Eskimo",
    "Australian Kelpie",
    "Australian Koolie",
    "Australian Labradoodle",
    "Australian Retriever",
    "Australian Shepherd",
    "Aussie Silk Terrier",
    "Australian Stumpy Tail Cattle Dog",
    "Australian Terrier",
    "Australian Yorkshire Terrier",
    "Austrian Black and Tan Hound ",
    "Austrian Brandlbracke ",
    "Austrian Shorthaired Pinscher",
    "Auvergne Pointing Dog ",
    "Azawakh",
    "Azawakh Borzoi",
    "Bagle Hound",
    "Bakharwal Dog",
    "Balkan Hound ",
    "Balkan Scenthound ",
    "Balkanski Gonic ",
    "Bando Bull",
    "Bandogge Mastiff",
    "Bangkaew",
    "Banjara Greyhound ",
    "Banter Bulldogge",
    "Barbado da Terceira ",
    "Barbet",
    "Barger Stock Feist",
    "Bascottie",
    "Basenji",
    "Basenji Pit",
    "Ba-Shar",
    "Baskimo",
    "Bassador",
    "Basschshund",
    "Basselier",
    "Basset Artesien Normand",
    "Basset Bleu de Gascogne",
    "Basset Bluetick",
    "Basset Bordeaux",
    "Basset Fauve de Bretagne",
    "Basset Foxhound",
    "Basset Heeler",
    "Basset Hound",
    "Basset Jack",
    "Basset Retriever",
    "Basset Shepherd",
    "Bassetoodle",
    "Bassky",
    "Bassmatian",
    "Basston",
    "Bassugg",
    "Bavarian Mountain Scent Hound",
    "Bea Griffon",
    "Beabull",
    "Beagi",
    "Beagle",
    "Beagle Chin",
    "Beagle Harrier",
    "Beagle Heeler",
    "Beagleman",
    "Beaglemation",
    "Beagle Pit",
    "Beagle Point",
    "Beagle Sheltie",
    "Beagle Shepherd",
    "Beaglier",
    "Beago",
    "Be-Apso",
    "Bearded Collie",
    "Bearded Tibetan Mastiff ",
    "Beaski",
    "Bea-Tzu",
    "Beauceron",
    "Bebasset Bordeaux",
    "Bedlington Terrier",
    "Bedlington Whippet",
    "Bedouin Shepherd Dog ",
    "Belgian Griffon",
    "Belgian Mastiff",
    "Belgian Shepadoodle",
    "Belgian Shepherd Groenendael",
    "Belgian Shepherd Laekenois",
    "Belgian Shepherd Malinois",
    "Belgian Shepherd Tervuren",
    "Belgian Shorthaired Pointer ",
    "Belgrade Terrier ",
    "Belusky",
    "Bench-legged Feist ",
    "Bergamasco",
    "Berger Blanc Suisse",
    "Berger de Picard",
    "Berger des Pyrenees",
    "Berger du Languedoc ",
    "Bernedoodle",
    "Bernefie",
    "Berner Chow",
    "Bernese Hound ",
    "Bernese Mountain Dog",
    "Bernese Rottie",
    "Bhagyari Kutta",
    "Bichomo",
    "Bichon Frise",
    "Bichon Havanais",
    "Bichon Yorkie",
    "Bichon-A-Ranian",
    "Bich-poo",
    "Biewer",
    "Billy",
    "Biro",
    "Biton",
    "Black and Tan Coonhound",
    "Black and Tan Coonoodle",
    "Black and Tan Coonshepherd",
    "Black and Tan Labhound",
    "Black and Tan Virginia Foxhound ",
    "Black Forest Hound",
    "Black Mouth Cur",
    "Black Mouth Pom Cur",
    "Black Norwegian Elkhound",
    "Black Russian Terrier",
    "Black Russian Wolfhound Terrier",
    "Bleu de Gascogne",
    "Bloodhound",
    "Blue Gascony Basset ",
    "Blue Heeler",
    "Blue Lacy",
    "Blue Picardy Spaniel",
    "Blue Paul Terrier",
    "Blue Spaniel",
    "Bluetick Walker",
    "Blue-Tzu Heeler",
    "Bluetick Coonhound",
    "Bluetick Coonhound Harrier",
    "Bocker",
    "Bo-Dach",
    "Bodacion",
    "Boerboel",
    "Boerboel Bernard",
    "Boerboel Pei",
    "Boerboel Pit",
    "Bogle",
    "Boglen Terrier",
    "Bohemian Shepherd",
    "Bohemian Terrier",
    "Bo-Jack",
    "Bolo-chi",
    "Bolo-Tzu",
    "Bologco",
    "Bolognese",
    "Bolonoodle",
    "Bonsai Bulldogge",
    "Borador",
    "Border Akbash Collie",
    "Border Akita Collie",
    "Border-Aussie",
    "Border Aussie Terrollie",
    "Border Basset",
    "Border Beagle",
    "Border Bluetick Collie",
    "Border Chow",
    "Border Collie",
    "Border Collie Bernard",
    "Border Collie Britt",
    "Border Collie Cocker",
    "Border Collie Pit",
    "Border Collie Pyrenees",
    "Border Heeler",
    "Border Jack",
    "Border Kelpie",
    "Border Malamute Collie",
    "Border Malamute Terrier",
    "Border Newfie",
    "Border Point",
    "Border Pom",
    "Border Rottie",
    "Border Schnollie",
    "Border Sheepdog",
    "Border Shepherd",
    "Border Springer",
    "Border Stack",
    "Border Terrier",
    "Border Whipollie",
    "Bordernese",
    "Bordoodle",
    "Borgi",
    "Borollie",
    "Borzoi",
    "Bosanski Ostrodlaki Gonic Barak ",
    "Bosapso",
    "BoShih",
    "Boskimo",
    "Bosmaraner",
    "Bosnian-Herzegovinian Sheepdog - Tornjak",
    "Bospin",
    "Bossi-Poo",
    "Bossie",
    "Bostalian",
    "Bostchon",
    "Bostillon",
    "Bostinese",
    "Boston Border Collie",
    "Boston Boxer",
    "Boston Cattle Dog",
    "Boston Chin",
    "Boston Huahua",
    "Boston Lab",
    "Boston Mastiff Terrier",
    "Boston Spaniel",
    "Boston Terrier",
    "Boston Yorkie",
    "Bouvier de Ardennes ",
    "Bouvier des Flandres",
    "Boweimar",
    "Bowsy Terrier ",
    "Bowzer",
    "Box Heeler",
    "Boxador",
    "Boxane",
    "Boxapoint",
    "Box-a-Shar",
    "Boxer",
    "Boxer Basset",
    "Boxer Bloodhound",
    "Boxer Chow",
    "Boxer Jack",
    "Boxer Shepherd",
    "Boxer Whippet",
    "Boxerdoodle",
    "Boxerman",
    "Boxita",
    "Boxollie",
    "Boxsky",
    "Boxspring",
    "Boxweiler",
    "Boykin Spaniel",
    "Bracco Italiano",
    "Braque De Puy",
    "Braque du Bourbonnais",
    "Braque Dupuy ",
    "Braque Francais ",
    "Brat",
    "Brazilian Bullmastiff ",
    "Brazilian Terrier",
    "Briard",
    "Briquet",
    "Briquet Griffon Vendeen ",
    "British Lupine Dog ",
    "Brittany Beagle",
    "Brittany Bourbonnais",
    "Brittany Spaniel",
    "Broholmer",
    "Broholmer Pit",
    "Broodle Griffon",
    "Brottweiler",
    "Brug",
    "Brussalier",
    "Brusselranian",
    "Brussels Griffon",
    "Brusston",
    "Bucciriscu Calabrese",
    "Buckley Mountain Feist",
    "Buggs",
    "Bukovina Sheepdog",
    "Buldogue Campeiro",
    "Bulgarian Shepherd Dog",
    "Bull Arab",
    "Bull Greyhound Terrier",
    "Bull Heeler Terrier",
    "Bull Jack",
    "Bull Mastweiler",
    "Bull Terrier",
    "Bullador",
    "Bull-Aussie",
    "Bullbasset Mastiff",
    "Bullboxer",
    "Bull-Boxer",
    "Bullboxer Pit",
    "Bullboxer Staff",
    "Bullboxer Staffy Bull",
    "Bulldog",
    "Bullenbeisser",
    "Bullmasador",
    "Bullmastiff",
    "Bullmastiff Shepherd",
    "Bullmatian",
    "Bullmatian Terrier",
    "Bulloxer",
    "Bull Chow Terrier",
    "Bull-Pei",
    "Bullwhip",
    "Bully Basset",
    "Bully Bordeaux",
    "Bully Chi",
    "Bully Kutta",
    "Bully Kutta Lab",
    "Bully Pitsky",
    "Bully Wheaten",
    "Bullypit",
    "Bushland Terrier",
    "Cadoodle",
    "Cairanian",
    "Cairland Terrier",
    "Cairmal",
    "Cairn Beagle",
    "Cairn Chin",
    "Cairn Corgi",
    "Cairn Terrier",
    "Cairnese",
    "Cairnoodle",
    "Cairoston",
    "Cairwich Terrier",
    "Cajun Squirrel Dog",
    "Cambodian Razorback Dog",
    "Canaan Dog",
    "Canadian Cur",
    "Canadian Eskimo Dog",
    "Canadian Inuit Dog",
    "Canarian Warren Hound ",
    "Canary Dog",
    "Cane Corso Italiano",
    "Canis Panther",
    "Canoe Dog ",
    "Cantel ",
    "Cão de Fila da Terceira",
    "Cão da Serra da Estrela",
    "Cão da Serra de Aires",
    "Cão de Castro Laboreiro",
    "Cão de Fila de São Miguel",
    "Cão de Gado Transmontano ",
    "Cão dos Mourey",
    "Caravan Hound",
    "Cardigan Corgi Pointer",
    "Cardigan Welsh Corgi",
    "Care-Tzu",
    "Carengi",
    "Carkie",
    "Carlin Pinscher",
    "Carnauzer",
    "Carolina Dog",
    "Carpathian Sheepdog",
    "Catahoula Bulldog",
    "Catahoula Dane",
    "Catahoula English Bulldog",
    "Catahoula Heeler",
    "Catahoula Leopard Dog",
    "Catahoula Rottie",
    "Catahoula Whippet",
    "Catalan Sheepdog",
    "Catalburun ",
    "Cattle Collie Dog",
    "Cattle Shepherd",
    "Caucasian Husky",
    "Caucasian Ovtcharka",
    "Caucasian Shepherd",
    "Caucasian Staffy Bull",
    "Cava-Chin",
    "Cavachon",
    "Cava-Corgi",
    "Cavador",
    "Cavalier King Charles Spaniel",
    "Cava-lon",
    "Cav-A-Malt",
    "Cav-A-Mo",
    "Cavanese",
    "Cavapom",
    "Cavapoo",
    "Cava-Shell",
    "Cavaton",
    "Cava-Tzu",
    "Cavestie",
    "Cavottish",
    "Central Anatolian Shepherd",
    "Central Asian Ovtcharka",
    "Cesky Fousek",
    "Cesky Terrier",
    "Chabrador",
    "Chacy Ranior",
    "Charlie Feist",
    "Chart Polski",
    "Chatham Hill Retriever",
    "Chatterdale",
    "Cheagle",
    "Cheeks",
    "Cheenese",
    "Cherokee Monarch",
    "Chesador",
    "Chesapeake Bay Retriever",
    "Chestie",
    "Chi Apso",
    "Chi Staffy",
    "Chi Staffy Bull",
    "Chi-Chi",
    "Chi-Chon",
    "Chidale",
    "Chien D' Artois",
    "Chien De L' Atlas",
    "Chiens Francaises ",
    "Chien-gris",
    "Chigi",
    "Chihuahua",
    "Chilier",
    "Chimation",
    "Chin",
    "China Jack",
    "Chinaranian",
    "Chineranian",
    "Chinese Chongqing Dog",
    "Chinese Crested",
    "Chinese Crestepoo",
    "Chinese Crestese",
    "Chinese Foo Dog",
    "Chinese Frise",
    "Chinese Imperial Dog",
    "Chinese Shar-Pei",
    "Chin-Ocker",
    "Chinook",
    "Chin-Pin",
    "Chin-wa",
    "Chion",
    "Chipin",
    "Chipit",
    "Chi-Poo",
    "Chippiparai",
    "Chiribaya Shepherd ",
    "Chisenji",
    "Chi-Rat",
    "Chi-Spaniel",
    "Chiweenie",
    "Chiwoxy",
    "Chizer",
    "Chongqing Hound",
    "Chonzer",
    "Chorkie",
    "Chortaj ",
    "Chow Chow",
    "Chow Hound Basset",
    "Chow Pei",
    "Chowpit",
    "Chow Shepherd",
    "Chuandong Hound",
    "Chug",
    "Chusky",
    "Chussel",
    "Cierny Sery",
    "Cimarron Uruguayo",
    "Cirneco Dell'Etna",
    "Clydesdale Terrier",
    "Clumber Lab",
    "Clumber Pei",
    "Clumber Spaniel",
    "Clumberstiff",
    "Cluminger Spaniel",
    "Cock-A-Chon",
    "Cockalier",
    "Cock-A-Mo",
    "Cockapin",
    "Cockapoo",
    "Cock-A-Tzu",
    "Cocker Chow",
    "Cocker Griffon",
    "Cocker Jack",
    "Cocker Pug",
    "Cocker Spaniel",
    "Cocker Weim",
    "Cocker Westie",
    "Cocker Wheaten",
    "Cockeranian",
    "Cocker-Pei",
    "CockerShnauz",
    "Cockinese",
    "Cogol",
    "Cojack",
    "Collie (Rough and Smooth)",
    "Colonial Cocker Spaniel",
    "Colorado Bulldog",
    "Combai",
    "Confetti Australian Shepherd",
    "Continental Bulldog",
    "Continental Toy Spaniel",
    "Coochi ",
    "Copica",
    "Cordoba Fighting Dog",
    "Corgi",
    "Corgi Basset",
    "Corgi Bichon",
    "Corgi Cattle Dog",
    "Corgi-Flat",
    "Corgi Pit",
    "Corgi Pointer",
    "Corgi Pug",
    "Corgi Schip",
    "Corgidor",
    "Corgipoo",
    "Corgiranian",
    "Corillon",
    "Corkie",
    "Corman Shepherd",
    "Cosheltie",
    "Coton Bolonka",
    "Coton de Tulear",
    "Coton Eskimo",
    "Coton Tzu",
    "Cotonese",
    "Cotralian",
    "Coydog",
    "Crested Apso",
    "Crested Beagle",
    "Crested Boxer",
    "Crested Cavalier",
    "Crested Havanese",
    "Crested Malt",
    "Crested Peke",
    "Crested Schnauzer",
    "Crested Tzu",
    "Crested Westie",
    "Crestoxie",
    "Cretan Hound",
    "Croatian Sheepdog",
    "Croatian Sheepsky",
    "Crustie",
    "Cumberland Sheepdog",
    "Curly-Coated Retriever",
    "Cypro Kukur ",
    "Czechoslovakian Wolfdog",
    "Czesky Terrier",
    "Dach-Griffon",
    "Dachsador",
    "Dachshund",
    "Dachsi Apso",
    "Dachsweiler",
    "Daisy Dog",
    "Dakotah Shepherd",
    "Dalmadoodle",
    "Dalmador",
    "Dalmatian",
    "Dalmatian Feist",
    "Dalmatian Heeler",
    "Dalmatian Husky",
    "Dameranian",
    "Dandie Dinmont Terrier",
    "Daniff",
    "Danish Broholmer",
    "Danish Mastiff",
    "Danish-Swedish Farmdog",
    "Das Pinscher ",
    "Dashalier",
    "Daug",
    "Decker Brat",
    "Decker Hunting Terrier",
    "Deerhound Shepherd",
    "Denmark Feist",
    "Deutsche Bracke ",
    "Deutsch Drahthaar",
    "Deutscher Wachtelhund",
    "Dingo",
    "Dingo Kelpie",
    "Dingo Podenco",
    "Doberdor",
    "Doberman Bulldog",
    "Doberman Pinscher",
    "Doberman Pit",
    "Doberman Shepherd",
    "Dobie-Basset",
    "Dobie Heeler",
    "Dobie Schnauzer",
    "Dobieton",
    "Dobocker",
    "Docker",
    "Dogo Argentino",
    "Dogo Cubano",
    "Dogo Pit",
    "Dogo Sardesco ",
    "Dogue Brasileiro",
    "Dogue de Bordeaux",
    "Domitius Maximus Mastiff",
    "Doodleman Pinscher",
    "Dorgi",
    "Dorkie",
    "Dorset Olde Tyme Bulldogge",
    "Double Doodle",
    "Doubull-Mastiff",
    "Doxie Cairn",
    "Doxie-Chin",
    "Doxie-Chon",
    "Doxie Heeler",
    "Doxiemo",
    "Doxie-Pin",
    "Doxiepoo",
    "Doxie Scot",
    "Doxle",
    "Drentse Patrijshond",
    "Drever",
    "Dumfriesshire Hound ",
    "Dunker ",
    "Dutch Shepherd Dog",
    "Dutch Smoushond",
    "Dutchie Chow Shepherd",
    "East-European Shepherd",
    "East Russian Coursing Hound ",
    "East Siberian Laika",
    "Elk-a-Bee ",
    "Elkhound",
    "Elkhound Shepherd",
    "Elk-Kee",
    "Eng-A-Poo",
    "Enga-Apso",
    "Engachon",
    "EngAm Bulldog / Olde Bulldog",
    "Engatzu Spaniel",
    "Englian Mastiff",
    "English Bantam Bulldogge",
    "English Boodle",
    "English Boston-Bulldog",
    "English Boxetter",
    "English Bull Springer",
    "English Bull Terrier Pit",
    "English Bullamute",
    "English Bulldog",
    "English Bullen Bordeaux Terrier ",
    "English Bulltyme",
    "English Bullweiler",
    "English Bully Staffy Bull Terrier",
    "English Catahoula Shepherd",
    "English Cocker Chow",
    "English Cocker Spaniel",
    "English Collie Shepherd",
    "English Coonhound",
    "English Coon Rottie",
    "English Cotralian",
    "English Foxhound",
    "English King",
    "English Mastweiler",
    "English Mini Foxker",
    "English Pointer",
    "English Presa Bulldog",
    "English Setter",
    "English Shepherd",
    "English Speagle",
    "English Springer Spaniel",
    "English Toy Cocker Spaniel",
    "English Toy Spaniel",
    "English Water Spaniel",
    "English White Terrier",
    "Entlebucher Pit",
    "Entlebucher Sennenhund",
    "Eskapoo",
    "Eskidor",
    "Eskifon",
    "Eskijack",
    "Eskimo Chi",
    "Eskimo Chin",
    "Eskimo Pit",
    "Eskimo Schnauzer",
    "Eskimo Shepherd",
    "Eskimo Yorkie",
    "Eskland",
    "Estonian Hound",
    "Estrela Mountain Dog",
    "Eurasier",
    "Euro Mountain Sheparnese",
    "Ewokian",
    "Farm Collie",
    "Fauve de Bretagne",
    "Faux Frenchbo Bulldog",
    "Feist",
    "Feist Chi",
    "Feist Tzu",
    "Field Spaniel",
    "Fila Brasileiro",
    "Fila Tosa",
    "Finnish Chow Spitz",
    "Finnish Hound",
    "Finnish Lapphund",
    "Finnish Spitz",
    "Flandoodle",
    "Flat-Coated Retriever",
    "Florida Cracker Cur",
    "Fo-Chon",
    "Foodle",
    "Formosan Mountain Dog",
    "Fo-Tzu",
    "Fourche Terrier",
    "Fox Terrier",
    "Foxhoodle",
    "Foxhound",
    "Foxingese",
    "Foxton",
    "Foxy Rat Terrier",
    "Foxy Russell",
    "Free-Lance Bulldog",
    "French Afghan Mastiff",
    "French Brittany Spaniel",
    "French Bull Jack",
    "French Bull Tzu",
    "French Bull Weiner",
    "French Bulldog",
    "French Bullhuahua",
    "French Bullnese",
    "French Bulloxer",
    "French Mastiff",
    "French Pin",
    "French Pointing Dog",
    "French Bull Rat Terrier",
    "French Spaniel",
    "French Tricolor Hound ",
    "French White and Black Hound ",
    "French White and Orange Hound ",
    "Frenchie Bichon",
    "Frenchie-Pei",
    "Frenchie Pug",
    "Frenchie Shepherd",
    "Frenchie Staff",
    "Frengle",
    "Galgo Español",
    "Gammel Dansk Hoensehund ",
    "Gascons-Saintongeois ",
    "Georgian Shepherd ",
    "Georgian Mountain Dog ",
    "Gerberian Shepsky",
    "German Anatolian Shepherd",
    "German Australian Shepherd",
    "German Groenendael",
    "German Hunt Terrier",
    "German Longhaired Pointer",
    "German Malinois",
    "German Pinscher",
    "German Rough-haired Pointing Dog ",
    "German Sheeppoodle",
    "German Sheltie Spitz",
    "German Shepherd Dog",
    "German Sheprador",
    "German Shorthair Toller",
    "German Shorthaired Lab",
    "German Shorthaired Pointer",
    "German Spitz",
    "German Spitz Giant",
    "German Spitz Medium",
    "German Spitz Shepherd",
    "German Spitz Small",
    "German Spitzpoo",
    "German Wirehaired Lab",
    "German Wirehaired Newfie",
    "German Wirehaired Pointer",
    "Giant Border Schnollie",
    "Giant Komondauzer",
    "Giant Maso Mastiff",
    "Giant Schnairedale",
    "Giant Schnauzer",
    "Giant Schnoodle",
    "Glechon",
    "Glen of Imaal Terrier",
    "Goberian",
    "Golddust Yorkshire Terrier",
    "Golden Akita Retriever",
    "Golden Border Retriever",
    "Golden Boxer",
    "Golden Bulldog",
    "Golden Bullmastiff Retriever",
    "Golden Chesabay",
    "Golden Chi Retriever",
    "Golden Chow Retriever",
    "Golden Cocker Retriever",
    "Golden Dox",
    "Golden Irish",
    "Golden Jack Retriever",
    "Golden Labrador",
    "Golden Mastiff",
    "Golden Mountain Dog",
    "Golden Newfie",
    "Golden Pei",
    "Golden Pyrenees",
    "Golden Retriever",
    "Golden Rottie Retriever",
    "Golden Saint",
    "Golden Sammy",
    "Golden Sheltie",
    "Golden Shepherd",
    "Golden Tibetan Tertriever",
    "Golden Toller Retriever",
    "Goldenshire",
    "Goldendoodle",
    "Goldmaraner",
    "Goldmation",
    "Gollie",
    "Gonczy Polski",
    "Gordon Chesabay",
    "Gordondoodle",
    "Gordon Setter",
    "Gordon Sheltie",
    "Gran Mastin de Borinquen ",
    "Grand Anglo-Francais ",
    "Grand Anglo-Français Blanc et Noir ",
    "Grand Anglo-Français Blanc et Orange ",
    "Grand Anglo-Français Tricolore ",
    "Grand Basset Griffon Vendeen",
    "Grand Bleu de Gascogne",
    "Grand Fauve de Bretagne",
    "Grand Gascon Saintongeois ",
    "Grand Griffon Vendeen ",
    "Great Bernese",
    "Great Dane",
    "Great Danebull",
    "Great Danesky",
    "Great Danoodle",
    "Great Golden Dane",
    "Great Pyredane",
    "Great Pyrenees",
    "Great Weimar",
    "Great Wolfhound",
    "Greater Swiss Mountain Dog",
    "Greek Hound",
    "Greek Sheepdog",
    "Greenland Dog",
    "Greyador",
    "Greyhound",
    "Greyhound Shepherd",
    "Griffon",
    "Griffairn Terrier",
    "Griffichon",
    "Griffon Bleu de Gascogne ",
    "Griffon Fauve de Bretagne ",
    "Griffon Nivernais",
    "Griffonese",
    "Griffonland",
    "Griffonshire",
    "Groenendael",
    "Groenendael Chow",
    "Grosser Münsterländer Vorstehhund",
    "Guatemalan Bull Terrier",
    "Gull Terr",
    "Hairless Khala",
    "Halden Hound",
    "Hamilton Hound",
    "Hangin’ Tree Cowdog ",
    "Hanoverian Hound ",
    "Hanoverian Scenthound ",
    "Hare Indian Dog",
    "Harlequin Pinscher",
    "Harrier",
    "Hava-Apso",
    "Hava-Boston",
    "Hava-Jack",
    "Hava Klee",
    "Hava-Wheat",
    "Havachin",
    "Havachon",
    "Havallon",
    "Havamalt",
    "Havanese",
    "Havanestie",
    "Havapeke",
    "Havashire",
    "Havashu",
    "Havaton",
    "Hawaiian Poi Dog",
    "Hellenikos Ichnilatis",
    "Hellenikos Poimenikos",
    "Hertha Pointer ",
    "Highland Maltie",
    "Himalayan Chamba Gaddi Dog",
    "Himalayan Mastiff Guard Dog",
    "Himalayan Sheepdog",
    "Hokkaido Dog",
    "Hovawart",
    "Hovie Gold Retriever",
    "Hug",
    "Hungarian Greyhound (Magyar Agar)",
    "Hungarian Kuvasz",
    "Hungarian Puli",
    "Hungarian Wire-haired Pointing Dog",
    "Hush Basset",
    "Huskimo",
    "Huskita",
    "Husky",
    "Husky Jack",
    "Husky Wheaten",
    "Hygenhund ",
    "Ibizan Hound",
    "Icelandic Sheepdog",
    "Imo-Inu",
    "Inca Hairless Dog",
    "Indian Mastiff",
    "Indian Spitz",
    "Irish Afghan Setter",
    "Irish Bostetter",
    "Irish Boston Terrier",
    "Irish Dane",
    "Irish Doodle",
    "Irish Glen Imaal Terrier",
    "Irish Jack Terrier",
    "Irish Lakeland Terrier",
    "Irish Mastiff",
    "Irish Red and White Setter",
    "Irish Setter",
    "Irish Staffordshire Bull Terrier",
    "Irish Terrier",
    "Irish Troodle",
    "Irish Water Spaniel",
    "Irish Wolfhound",
    "Irish Wolf Greyhound",
    "Irish Wolfsky",
    "Istrian Coarse-haired Hound ",
    "Istrian Shorthaired Hound",
    "Italian Greyenji",
    "Italian-Bichon",
    "Italian Border Greyollie",
    "Italian Bulldogge",
    "Italian Cairn",
    "Italian Daniff",
    "Italian Doxie",
    "Italian Eskimo",
    "Italian Greagle",
    "Italian Grey Min Pin",
    "Italian Greycrested",
    "Italian Greyhound",
    "Italian Greyhuahua",
    "Italian Hound",
    "Italian Papihound",
    "Italian Spinoni",
    "Italian Tzu",
    "Jacairn",
    "Ja-Chon",
    "Jack Chi",
    "Jack Highland Terrier",
    "Jack Pit",
    "Jack Russell Greyhound",
    "Jack Russell Terrier",
    "Jack Tzu",
    "Jack-A-Bee",
    "Jack-A-Poo",
    "Jack-A-Ranian",
    "Jackie-Bichon",
    "Jack-Rat Terrier",
    "Jackshund",
    "Jackweiler",
    "Jafox",
    "Jagdterrier",
    "Jaland",
    "Jamthund ",
    "Japanese Chow Spitz",
    "Japanese Spaniel (Chin)",
    "Japanese Spitz",
    "Japanese Spitz Chi",
    "Japanese Terrier",
    "Japanese Thai Ridgespitz",
    "Japanese Tosa",
    "Japeke",
    "Japillon",
    "Japug",
    "Jarkie",
    "Jatese",
    "Jatzu",
    "Jindo",
    "Jug",
    "Kai Dog",
    "Kangal Dog",
    "Kangaroo Dog",
    "Kanni",
    "Karabash",
    "Karelian Bear Dog",
    "Karelian Bear Laika ",
    "Karelo-Finnish Laika ",
    "Karst Shepherd",
    "Kashon",
    "Kattai Nai",
    "Keagle",
    "Keeshond",
    "Kelb Tal-Fenek",
    "Kelpie Corgi",
    "Kelpie Heeler",
    "Kelpie Lab",
    "Kelpie Shepherd",
    "Kelpie Staff",
    "Kemmer Feist",
    "Kemmer Stock Hybrid Squirrel Dog",
    "Kerry Beagle ",
    "Kerry Blue Schnauzer",
    "Kerry Blue Terrier",
    "Kerry Wheaten",
    "Kimola",
    "King Cavrin",
    "King Charles Spaniel",
    "King Charles Yorkie",
    "King Pin",
    "King Rat",
    "King Schnauzer",
    "King Shepherd",
    "King Wheaten",
    "Kishu Ken",
    "Klein Poodle",
    "Kobetan",
    "Kokoni",
    "Komba",
    "Komondor",
    "Kooikerhondje",
    "Koolie",
    "Korean Dosa Mastiff",
    "Krasky Ovcar",
    "Kromfohrlander ",
    "Kugsha Dog",
    "Kukkal",
    "Kunming Dog",
    "Kuri",
    "Kuvasz",
    "Kyi-Leo®",
    "Lab'Aire",
    "Lab Apso",
    "Lab Pei",
    "Lab-Pointer",
    "Labahoula",
    "Labany",
    "Labbe",
    "Labernard",
    "Labernese",
    "Labloodhound",
    "Labmaraner",
    "Labollie",
    "Labrabull",
    "Labradane",
    "Labradinger",
    "Labradoodle",
    "Labradoodle Australian",
    "Labradoodle Miniature",
    "Labrador Corso",
    "Labrador Husky",
    "Labrador Retriever",
    "Labraheeler",
    "Labrahuahua",
    "Labrakita",
    "Labralas",
    "Labrasenji",
    "Labrastaff",
    "Labrottie",
    "Lacasapoo",
    "La-Chon",
    "Lagotto Romagnolo",
    "Laizhou Hong",
    "Lakeland Terrier",
    "Lakota Mastino",
    "Lancashire Heeler",
    "Landseer",
    "Lapinporokoira",
    "La Pom",
    "Lapphund",
    "Lapponian Herder",
    "Large Munsterlander",
    "Larson Lakeview Bulldogge",
    "Latvian Hound",
    "Leavitt Bulldog",
    "LeoBerner",
    "Leonberger",
    "Leopard Cur",
    "Levesque ",
    "Lha-Basset",
    "Lha-Cocker",
    "Lhaffon",
    "Lhasa Apso",
    "Lhasa-Corgi",
    "Lhasa-Coton",
    "Lhasa Jack",
    "Lhasa Pin",
    "Lhasa Vendeen",
    "Lhasalier",
    "Lhasanese",
    "Lhasapoo",
    "Lhatese",
    "Lithuanian Hound",
    "Llewellin Setter",
    "Longhaired Whippet ",
    "Louisiana Catahoula Leopard Dog",
    "Löwchen  (Little Lion Dog)",
    "Lucas Terrier",
    "Lundehund",
    "Lurcher",
    "Maze Bulk ",
    "Magyar Agar ",
    "Mahratta Greyhound ",
    "Majestic Tree Hound",
    "Majorca Shepherd Dog ",
    "Malamute Pei",
    "Malchi",
    "Malinois Akita",
    "Malinois Greyhound",
    "Malinois Mastiff",
    "Malinois X",
    "Mally Foxhound",
    "Mal-Shi",
    "Malteagle",
    "Maltese",
    "Maltichon",
    "Malti-Pin",
    "Maltipom",
    "Malti-Poo",
    "Malti-Pug",
    "Malti-Py",
    "Malton",
    "Mammut Bulldog",
    "Manchester Terrier",
    "Maremma Kelpie",
    "Maremma Sheepdog",
    "Maremma Shepherd",
    "Markiesje",
    "Mastador",
    "Masti-Bull",
    "Mastidoodle",
    "Mastiff",
    "Mastiff Shepherd",
    "Mauxie",
    "Mauzer",
    "Maze Bulk ",
    "McNab",
    "Meagle",
    "Medium Poodle",
    "Mexican Hairless",
    "Middle Asian Ovtcharka",
    "Mi-Ki",
    "Mini Australian Shepterrier",
    "Mini Cairn Pin",
    "Mini Coonhound",
    "Mini English Cocker",
    "Mini Fo-Chon",
    "Mini Foxillon",
    "Mini Foxker",
    "Mini Foxy Russell",
    "Mini Kerry Blue Schnauzer",
    "Mini Schnauzer Jack",
    "Mini St. Bernard",
    "Mini Texas Heeler",
    "Miniature American Eskimo",
    "Miniature American Shepherd",
    "Miniature Aussiedoodle",
    "Miniature Australian Bulldog",
    "Miniature Australian Shepherd",
    "Miniature Border Schnollie",
    "Miniature Boxer",
    "Miniature Bull Terrier",
    "Miniature Bulldog",
    "Miniature English Bulldach",
    "Miniature English Bulldog",
    "Miniature Fox Terrier",
    "Miniature French Bull Terrier",
    "Miniature French Schnauzer",
    "Miniature German Spitzpoo",
    "Miniature Golden Retriever",
    "Miniature Goldendoodle",
    "Miniature Gordondoodle",
    "Miniature Labradoodle",
    "Miniature Pinscher",
    "Miniature Poodle",
    "Miniature Saint Bernard",
    "Miniature Schnairedale",
    "Miniature Schnaupin",
    "Miniature Schnauzer",
    "Miniature Schnauzzie",
    "Miniature Schnoxie",
    "Miniature Shar-Pei",
    "Miniboz",
    "Minnie Jack",
    "Minnie Parson",
    "Mioritic Sheepdog",
    "Mi-orkie",
    "Mollett Victorian Bulldog",
    "Molossus",
    "Mongrel (Mutt)",
    "Montaimboeuf",
    "Morkie",
    "Morkshire Terrier",
    "Moscow Toy Terrier",
    "Moscow Vodolaz ",
    "Moscow Watchdog",
    "Moscow Water Dog",
    "Mountain Bulldog",
    "Mountain Cur",
    "Mountain Cur Shepherd",
    "Mountain Feist",
    "Mountain Jack Cur",
    "Mountain Mastiff",
    "Mountain View Cur",
    "Moyen Poodle",
    "Mucuchies",
    "Mudhol Hound",
    "Mudi",
    "Muggin",
    "Mullins Feist",
    "Munsterlander",
    "Muscle Mastiff",
    "Native American Indian Dog",
    "Native American Shepherd",
    "Native American Village Dog",
    "Neapolitan Boxer",
    "Neapolitan Mastiff",
    "Neapolitan Shepherd",
    "Nebolish Mastiff",
    "Nehi Saint Bernard",
    "Nenets Herding Laika ",
    "Neo Bullmastiff",
    "New Guinea Singing Dog",
    "New Shep",
    "New Zealand Heading Dog",
    "New Zealand Huntaway",
    "Newfie Dane",
    "Newfoundland",
    "Newfypoo",
    "Norrbottenspets",
    "Norfolk Spaniel",
    "Norfolk Terrier",
    "Nortese",
    "North American Indian Dog (North AID)",
    "North American Miniature Australian Shepherd",
    "North Country Beagle",
    "Northeasterly Hauling Laika ",
    "Northern Inuit Dog",
    "Norwegian Buhund",
    "Norwegian Elkhound",
    "Norwegian Hound ",
    "Norwegian Lundehund",
    "Norwich Terrier",
    "Nova Scotia Duck-Tolling Retriever",
    "Ol' Southern Catch Dog",
    "Old Anglican Bulldogge",
    "Old Danish Chicken Dog",
    "Old Deerhound Sheepdog",
    "Old Doxie Sheepdog",
    "Old English Mastiff",
    "Old English Sheepdog (Bobtail)",
    "Olde Boston Bullchi",
    "Olde Boston Bulldogge",
    "Olde Double Bully",
    "Olde English Bulldogge",
    "Olde Pit Bulldogge",
    "Olde Staff Bulldogge",
    "Olde Staffybull Bulldogge",
    "Olde Victorian Bulldogge",
    "Old-Time Farm Shepherd ",
    "Ori Pei",
    "Original English Bulldogge",
    "Original Mountain Cur",
    "Otterhound",
    "Otto Bulldog",
    "Owczarek Podhalanski",
    "Paisley Terrier",
    "Pakistani Bull Dog (Gull Dong)",
    "Pakistani Bull Terrier (Pakistani Gull Terr)",
    "Pakistani Mastiff (Pakisani Bully Kutta)",
    "Pakistani Shepherd Dog (Bhagyari Kutta)",
    "Pakistani Tazi Hound ",
    "Pakistani Vikhan Dog ",
    "Panda Shepherd",
    "Pandikona",
    "Papastzu",
    "Paperanian",
    "Papichon",
    "Papigriffon",
    "Papijack",
    "Papillon",
    "Papimo",
    "Papi-poo",
    "Papitese",
    "Papshund",
    "Pariah Dog",
    "Parnell's Carolina Cur",
    "Parson Russell Terrier",
    "Parsonhund",
    "Pastor Garafiano ",
    "Patterdale Doxie",
    "Patterdale Shepherd",
    "Patterdale Terrier",
    "Patterjack",
    "Patterland Terrier",
    "Patti",
    "Patton Terrier",
    "Peagle",
    "Peek-A-Pom",
    "Pek-A-Rat",
    "Peka-A-West",
    "Pekalier",
    "Pekarin",
    "Peke-A-Chon",
    "Peke-A-Chow",
    "Peke-A-Jack",
    "Peke-A-Pap",
    "Peke-A-Pin",
    "Peke-A-Tese",
    "Pekehund",
    "Peke-Italian",
    "Pekepoo",
    "Pekingese",
    "Pembroke Cocker Corgi",
    "Pembroke Corgi Pointer",
    "Pembroke Sheltie",
    "Pembroke Welsh Corgi",
    "Pencil-tail Feist ",
    "Perdiguero de Burgos",
    "Perdiguero Navarro ",
    "Perro Cimarron",
    "Perro de Pastor Mallorquin ",
    "Perro de Presa Canario",
    "Perro de Presa Mallorquin",
    "Perro Dogo Mallorquin",
    "Perro Ratonero Andaluz",
    "Persian Sarabi Dog",
    "Peruvian Inca Orchid (PIO)",
    "Petit Basset Griffon Vendeen",
    "Petit Bleu de Gascogne",
    "Petit Brabancon",
    "Petit Gascon Saintongeois ",
    "Petite Goldendoodle",
    "Petite Labradoodle",
    "Pharaoh Hound",
    "Pharaoh Lab",
    "Phu Quoc Ridgeback Dog",
    "Picardy Spaniel ",
    "Pineranian",
    "Pinny-Poo",
    "Pin-Tzu",
    "Pit Boodle",
    "Pit Bull Terrier",
    "Pit Heeler",
    "Pit Pei",
    "Pit Pin",
    "Pitsky",
    "Pitweiler",
    "Plica",
    "Plotkita",
    "Plottahoula",
    "Plott Hound",
    "Plott Rottie",
    "Plott Walker",
    "Plummer Terrier",
    "Pocket Beagle",
    "Pocket Pitbull",
    "Podenco Ibicenco",
    "Pointer",
    "Pointer Bay",
    "Pointer Pit",
    "Poitevin ",
    "Polish Hound",
    "Polish Lowland Sheepdog",
    "Polish Tatra Sheepdog",
    "Pom Terrier",
    "Pom-A-Nauze",
    "Pomapoo",
    "Pom-A-Pug",
    "Pomchi",
    "Pom-Coton",
    "Pomeagle",
    "Pomeranian",
    "Pomerat",
    "Pomimo",
    "Pom-Kee",
    "Pom-Shi",
    "Pom-Silk",
    "Pomsky",
    "Pomston",
    "Pont-Audemer Spaniel ",
    "Poochin",
    "Poodle",
    "Poogle",
    "Poolky",
    "Poos",
    "Poo-Shi",
    "Pootalian",
    "Poo-Ton",
    "Poovanese",
    "Porcelaine",
    "Portuguese Podengo",
    "Portuguese Pointer",
    "Portuguese Sheepdog",
    "Portuguese Water Dog",
    "Posavac Hound",
    "Poshies",
    "Potsdam Greyhound ",
    "Powderpap",
    "Prague Farm Dog ",
    "Prazsky Krysavik",
    "Presa Bulldog",
    "Presa Canario",
    "Presa Dane",
    "Price Boar Beisser ",
    "Pudelpointer",
    "Pug",
    "Pugairn",
    "Pugalier",
    "Pug-A-Mo",
    "Pugapoo",
    "Pug-Coton",
    "Pugese",
    "Puggat",
    "Puggit",
    "Puggle",
    "Pughasa",
    "Pugillon",
    "Puginese",
    "Pugland",
    "Pugmatian",
    "Pugottie",
    "Pugshire",
    "Pugwich",
    "Pug Pit",
    "Pug Shiba",
    "Pug-Zu",
    "Puli (Pulik)",
    "Pumi",
    "Pungsan Dog",
    "Pushon",
    "Pyrador",
    "Pyredoodle",
    "Pyrenean Mastiff",
    "Pyrenean Mountain",
    "Pyrenees Husky",
    "Pyrenees Pit",
    "Pyrenean Shepherd",
    "Queen Elizabeth Pocket Beagle",
    "Queensland Heeler",
    "Raccoon Dog ",
    "Rafeiro do Alentejo",
    "Raggle",
    "Rajapalayam",
    "Rampur Greyhound",
    "Rashon",
    "Rastreador Brasileiro ",
    "Rat-A-Pap",
    "Rat Apso",
    "Rat Basset",
    "Rat-Cha",
    "Rat Feist",
    "Rat Heeler",
    "Rat Pei",
    "Rat Terrier",
    "Ratahoula",
    "Ratese",
    "Ratshi Terrier",
    "Ratshire Terrier",
    "Rattle",
    "Rattle Griffon",
    "Reagle",
    "Redbone Coonhound",
    "Redbone Lab",
    "Redbone Shepherd",
    "Red-Tiger Bulldog",
    "Red Wolf",
    "Rhodesian Beagle",
    "Rhodesian Bernard",
    "Rhodesian Boxer",
    "Rhodesian Collie",
    "Rhodesian Labrador",
    "Rhodesian Pit",
    "Rhodesian Ridgeback",
    "Rhodesian Rottie",
    "Rhodesian Shepherd",
    "Rhodesian Whippet",
    "Roman Rottweiler",
    "Romanian Mioritic Shepherd Dog",
    "Rott Pei",
    "Rottaf",
    "Rotterman",
    "Rotticorso",
    "Rottie Basset",
    "Rottie Bordeaux",
    "Rottie Chow",
    "Rottie Cocker",
    "Rottie Corgi",
    "Rottie Heeler",
    "Rottie Shepherd",
    "Rottle",
    "Rottmatian",
    "Rottsky",
    "Rottweiler",
    "Rough Collie",
    "Rough Rhodesian Collie",
    "Rumanian Sheepdog",
    "Running Walker Foxhound ",
    "Rus-A-Pei",
    "Russian Bear Schnauzer",
    "Russian Harlequin Hound ",
    "Russian Hound",
    "Russian Bandog",
    "Russian Spaniel",
    "Russian Toy",
    "Russian Tsvetnaya Bolonka",
    "Russian Wolfhound",
    "Russo-European Laika ",
    "Rustralian Terrier",
    "Saarlooswolfhond",
    "Sabueso Español",
    "Sage Ashayeri",
    "Sage Koochee ",
    "Sage Mazandarani ",
    "Saint Berdoodle",
    "Saint Bermastiff",
    "Saint Bernard",
    "Saint Bernese",
    "Saint Bernewfie",
    "Saint Chesa Bay Bernard",
    "Saint Dane",
    "Saint Pyrenees",
    "Saint Shepherd",
    "Salish Woolly Dog",
    "Saluki",
    "Saluki Deerhound",
    "Saluki Greyhound",
    "Saluki Sloughi",
    "Sammy Chow",
    "Sammy Shepherd",
    "Samollie",
    "Samoyed",
    "Samusky",
    "Sanshu Dog ",
    "Sapsari ",
    "Sarail Hound ",
    "Sarplaninac",
    "Sceagle",
    "Schapendoes",
    "Schapso",
    "Schiller Hound ",
    "Schip-A-Pom",
    "Schip Coton",
    "Schipese",
    "Schipper-Chi",
    "Schipper Geraussie Shepherd",
    "Schipperke",
    "Schipper-Pin",
    "Schipper-Poo",
    "Schnairedale",
    "Schnau-Tzu",
    "Schnauzador",
    "Schnauzer",
    "Schnauzer Pit",
    "Schneagle",
    "Schnekingese",
    "Schnese",
    "Schnocker",
    "Schnoodle",
    "Schnug",
    "Schweenie",
    "Scobo Terrier",
    "Scoland Terrier",
    "Scolden Terrier",
    "Scoodle",
    "Scorkie",
    "Sco-Shi",
    "Scotch Collie",
    "Scotch Terrier",
    "Scotchi",
    "Scotchon",
    "Scotti Apso",
    "Scottie Schnauzer",
    "Scottish Cocker",
    "Scottish Deerhound",
    "Scottish Deer Greyhound",
    "Scottish Terrier (Scottie)",
    "Scottish-Skye Terrier",
    "Sealydale Terrier",
    "Sealyham Terrier",
    "Segugio Italiano",
    "Seidenspitz",
    "Seppala Siberian Sleddog",
    "Serbian Defence Dog ",
    "Serbian Hound ",
    "Sharberian Husky",
    "Sharbo",
    "Sharmatian",
    "Sharp Eagle",
    "Shar-Pei",
    "Shar-Poo",
    "Shar Tzu",
    "Sheepadoodle",
    "Shel-Aussie",
    "Shelchon",
    "Shelestie",
    "Shelillon",
    "Sheltidoodle",
    "Sheltie Heeler",
    "Sheltie Inu",
    "Sheltie Pin",
    "Sheltie Pug",
    "Sheltie Shepherd",
    "Sheltie Tzu",
    "Shepadoodle",
    "Shepherd Pei",
    "Shepherd Pit",
    "Shepherd Tzu",
    "Shepnees",
    "Sheprador",
    "Shepsky",
    "Sheptese",
    "Shepweiler",
    "Shetland Sheepdog (Sheltie)",
    "Shiba-Chi",
    "Shiba Corgi",
    "Shiba Inu",
    "Shiba Lab",
    "Shibos",
    "ShiChi",
    "Shichon",
    "Shiffon",
    "Shih Apso",
    "Shih Tzu",
    "Shih-Mo",
    "Shih-Poo",
    "Shika Inu ",
    "Shikoku",
    "Shiloh Shepherd",
    "Shinese",
    "Shiranian",
    "Shocker",
    "Shockerd",
    "Shollie",
    "Shorgi",
    "Shorkie Tzu",
    "Shorty Bull",
    "Shug",
    "Sibercaan",
    "Siberian Boston",
    "Siberian Cocker",
    "Siberian Collisky",
    "Siberian Husky",
    "Siberian Indian Dog",
    "Siberian Keeshond",
    "Siberian Kelpsky",
    "Siberian Laika",
    "Siberian Retriever",
    "Siberian Shiba",
    "Siberpoo",
    "Silkchon",
    "Silken Windhound",
    "Silkese",
    "Silkin",
    "Silkinese",
    "Silkland Terrier",
    "Silkshire Terrier",
    "Silkshund",
    "Silky Cocker",
    "Silky Coton",
    "Silky Jack",
    "Silky Pug",
    "Silky Terrier",
    "Silky Tzu",
    "Silkyhuahua",
    "Silky-Lhasa",
    "Silky-Pin",
    "Silkzer",
    "Simaku ",
    "Ski-Border",
    "Skilky Terrier",
    "Skip-Shzu",
    "Skye-Pap",
    "Skye Terrier",
    "Skypoo",
    "Sloughi",
    "Slovakian Hound",
    "Slovakian Rough Haired Pointer",
    "Slovakian Wirehaired Pointer",
    "Slovensky Cuvac",
    "Slovensky Hrubosrsty Stavac",
    "Slovensky Kopov",
    "Smalandsstovare",
    "Small Bernese Hound",
    "Small Greek Domestic Dog",
    "Small Jura Hound",
    "Small Lucerne Hound",
    "Small Munsterlander",
    "Small Schwyz Hound",
    "Small Swiss Hound",
    "Smithfield ",
    "Smooth Collie",
    "Smooth Fox Terrier",
    "Smooth Foxy Boerboel",
    "Smooth Foxybull Terrier",
    "Smooth Poxer",
    "Smooth Rhodesian Collie",
    "Sniffon",
    "Snorkie",
    "Soft Coated Golden",
    "Soft Coated Wheaten Terrier",
    "Soft Coated Wheatzer",
    "Soft Coated Woxer",
    "South Russian Ovtcharka",
    "Southern Hound",
    "Spanador",
    "Spangold Retriever",
    "Spaniel de Pont-Audemer ",
    "Spanish Bulldog",
    "Spanish Hound ",
    "Spanish Mastiff",
    "Spanish Water Dog",
    "Spinone Italiano",
    "Spreagle",
    "Springer Basset",
    "Springer Husky",
    "Springer Pit",
    "Springer Rottie",
    "Springer Spaniel",
    "Springerdoodle",
    "Sprocker Spaniel",
    "Sprollie",
    "Srpski Gonic ",
    "Srpski Planinski Gonic ",
    "Srpski Trobojni Gonic ",
    "St. Germain Pointing Dog ",
    "St. John's Water Dog",
    "St. Weiler",
    "Stabyhoun",
    "Staffordshire Bull Terrier",
    "Staffy Bull Bordeaux",
    "Staffy Bull Bullmastiff",
    "Staffy Bull Pei",
    "Staffy Bull Pit",
    "Staffy Bull Pug",
    "Staffy Bull Wolfhound",
    "Staffy Heeler",
    "Staffy Pit",
    "Staghound",
    "Standard American Eskimo",
    "Standard Auss-Tzu",
    "Standard German Spitzpoo",
    "Standard Gordondoodle",
    "Standard Poodle",
    "Standard Schnairedale",
    "Standard Schnauzer",
    "Standard Schnoodle",
    "Standard Siberian Schusky",
    "Stephens' Stock Mountain Cur",
    "Stichelhaar ",
    "Strellufstover ",
    "Stumpy Tail Cattle Dog",
    "Styrian Roughhaired Mountain Hound ",
    "Sulimov dog ",
    "Sussex Spaniel",
    "Swedish Elkhound ",
    "Swedish Lapphund",
    "Swedish Vallhund",
    "Swiss Hound ",
    "Swiss Laufhund ",
    "Swiss Newfie",
    "Swiss Shorthaired Pinscher ",
    "Swissneese",
    "Swissy Saint",
    "Taco Terrier",
    "Tahltan Bear Dog",
    "Taigan",
    "Taiwan Dog",
    "Talbot",
    "Tamaskan Dog",
    "Tangkhul Hui",
    "Tasmanian Smithfield ",
    "Tasy ",
    "Taylor's Bulldane",
    "Teacup Poodle",
    "Teddy Roosevelt Terrier",
    "Telomian",
    "Tenterfield Terrier",
    "Tepeizeuintli",
    "Terceira Mastiff",
    "Terri-Poo",
    "Tesem",
    "Texas Blue Lacy",
    "Texas Heeler",
    "Thai Bangkaew Dog",
    "Thai Boxridge",
    "Thai Ridgeback",
    "The Carolina Dog",
    "Thornburg Feist",
    "Thylacine",
    "Tibalier",
    "Tibetan Chin",
    "Tibetan Golden Mastiff",
    "Tibetan KyiApso ",
    "Tibetan Mastiff",
    "Tibetan Pap",
    "Tibetan Pom",
    "Tibetan Pug",
    "Tibetan Spaltese",
    "Tibetan Spaniel",
    "Tibetan Staffy Spaniel",
    "Tibetan Terrier",
    "Timber Wolf",
    "Titan Bull-Dogge",
    "Titan Terrier",
    "Toller Pit",
    "Torkie",
    "Tornjak",
    "Tosa Inu",
    "Tosa-Pei",
    "Toxirn",
    "Toy American Eskimo",
    "Toy Australian Shepherd",
    "Toy Bulldog",
    "Toy Fox Beagle",
    "Toy Fox Pinscher",
    "Toy Fox Terrier",
    "Toy Foxie Doxie",
    "Toy Foxillon",
    "Toy Foxingese",
    "Toy Foxker",
    "Toy Foxton",
    "Toy German Spitz",
    "Toy German Spitzpoo",
    "Toy Gordondoodle",
    "Toy Manchester Terrier",
    "Toy Poodle",
    "Toy Poxer",
    "Toy Rat Doxie",
    "Toy Trawler Spaniel",
    "Transylvanian Hound",
    "Treeing Cur",
    "Treeing Tennessee Brindle",
    "Treeing Walker Coonhound",
    "Ttoodle ",
    "Tuareg Sloughi",
    "Turkish Mastiff",
    "Turkish Yellow Dog",
    "Turnspit Dog",
    "Tweed Water Spaniel",
    "Twatha Utonagan",
    "Tyroler Bracke ",
    "Tzu Basset",
    "Ultimate Mastiff",
    "Utonagan",
    "Valley Bulldog",
    "Vanguard Bulldog",
    "Victorian Boston Bulldog",
    "Victorian Bulldog",
    "Victorian Bulldog (Mollett)",
    "Villano de Las Encartaciones",
    "Vizmaraner",
    "Vizsla",
    "Vizsla Pin",
    "Volpino Italiano ",
    "Vucciriscu",
    "Walker Beagle",
    "Walker Greyhound",
    "Wauzer",
    "Wee-Chon",
    "Weeranian",
    "Weiler Dane",
    "Weimaraner",
    "Weimardoodle",
    "Weimarman",
    "Weim-Pei",
    "Wel-Chon",
    "Welsh Corgi",
    "Welsh Hound ",
    "Welsh Sheepdog",
    "Welsh Springer Spaniel",
    "Welsh Terrier",
    "Weshi",
    "West Highland Doxie",
    "West Highland Husky",
    "West Highland White Terrier (Westie)",
    "West of Argyll Terrier",
    "West Russian Coursing Hound ",
    "West Siberian Laika",
    "Westeke",
    "Western Mountain Cur",
    "Westie Staff",
    "Westie-Laso",
    "Westiepoo",
    "Westillon",
    "Westimo",
    "Weston",
    "Westphalian Dachsbracke ",
    "Wetterhoun",
    "Wheaten Pei",
    "Wheaten Terrier",
    "Whipador",
    "Whipperman",
    "Whippet",
    "Whippet Greyhound",
    "Whippet Shepherd",
    "White Bloodhound",
    "White English Bulldog",
    "White German Shepherd",
    "White Shepherd",
    "White Swiss Shepherd",
    "Whoodle",
    "Wire Fox Pinscher",
    "Wire Foxker",
    "Wire Foxy Boerboel",
    "Wire Hair Snauzer",
    "Wirehaired Fox Terrier",
    "Wirehaired Pointing Griffon",
    "Wirehaired Vizsla",
    "Wirelsh Terrier",
    "Wire-Poo",
    "Wolador",
    "Wolamute",
    "Wolf Hybrid",
    "Wolfdog",
    "Woodle",
    "Wowauzer",
    "Xoloitzcuintle",
    "Xochaso ",
    "Yakutian Laika",
    "Yoranian",
    "Yorkie Pin",
    "Yorkie Russell",
    "Yorkie-Apso",
    "Yorkie-ton",
    "Yorkillon",
    "Yorkinese",
    "Yorkipoo",
    "Yorkshire Terrier",
    "Yorksky",
    "Yorktese",
    "Yorwich",
    "Yugoslavian Hound",
    "Zuchon",
  ];

  function setupBreedSelect(containerId, searchId, selectedId, optionsId) {
    var optionsContainer = document.getElementById(optionsId);
    if (!optionsContainer) return;

    var html = breedsList
      .map(function (breed) {
        return (
          '<div class="option-item" data-value="' +
          breed +
          '">' +
          breed +
          "</div>"
        );
      })
      .join("");
    optionsContainer.innerHTML = html;

    var selectContainer = document.getElementById(containerId);
    var searchInput = document.getElementById(searchId);
    var selected = document.getElementById(selectedId);
    if (!selectContainer || !selected) return;
    var options = optionsContainer.querySelectorAll(".option-item");

    selected.addEventListener("click", function () {
      optionsContainer.classList.toggle("show-options");
      if (searchInput) {
        searchInput.focus();
        searchInput.style.zIndex = 2;
      }
    });

    if (searchInput) {
      searchInput.addEventListener("input", function (e) {
        var searchText = e.target.value.toLowerCase();
        options.forEach(function (opt) {
          if (opt.textContent.toLowerCase().includes(searchText)) {
            opt.classList.remove("hidden");
          } else {
            opt.classList.add("hidden");
          }
        });
      });
    }

    options.forEach(function (opt) {
      opt.addEventListener("click", function () {
        selected.textContent = this.textContent;
        optionsContainer.classList.remove("show-options");
        if (searchInput) {
          searchInput.value = "";
          searchInput.style.zIndex = -1;
        }
        options.forEach(function (o) {
          o.classList.remove("hidden");
        });
        var continueBtn = document.getElementById("continue-button-5");
        if (continueBtn) continueBtn.disabled = false;
      });
    });

    document.addEventListener("click", function (e) {
      if (selectContainer && !selectContainer.contains(e.target)) {
        optionsContainer.classList.remove("show-options");
        if (searchInput) {
          searchInput.value = "";
          searchInput.style.zIndex = -1;
        }
        options.forEach(function (o) {
          o.classList.remove("hidden");
        });
      }
    });
  }

  setupBreedSelect(
    "breed-select-1",
    "breedSearch",
    "selectedBreed",
    "breedOptions",
  );
  setupBreedSelect(
    "breed-select-2",
    "breedSearch2",
    "selectedBreed2",
    "breedOptions2",
  );
}

function showpage(pageNumber) {
  for (let i = 1; i <= 12; i++) {
    let page = document.getElementById(`quiz-page-${i}`);
    if (i === pageNumber) {
      page.style.display = "block";
    } else {
      page.style.display = "none";
    }
  }

  const petDetails = getPetDetails();
  let placeholders = document.querySelectorAll(`.pet-name-placeholder`);
  for (let i = 0; i < placeholders.length; i++) {
    placeholders[i].textContent = petDetails.name;
  }
  const emailSectionContainer = document.querySelector(
    ".cus-newsletter-container",
  );
  if (emailSectionContainer) {
    emailSectionContainer.setAttribute("data-active-page", pageNumber);
  }

  // Scroll to top on page change
  window.scrollTo({ top: 0, behavior: "smooth" });

  // show faqs only on page 12
  const showFaqValue = document.querySelector(".show_faq_on_results");
  const faqSection = document.querySelector(".collection-faq-section");
  if (
    faqSection &&
    showFaqValue &&
    showFaqValue?.innerText?.trim() === "true"
  ) {
    if (pageNumber === 12) {
      faqSection.style.display = "block";
    } else {
      faqSection.style.display = "none";
    }
  }
}

function setPetDetails(detailKey, detailValue) {
  // Get existing details from localstorage
  let petDetails = getPetDetails();

  // Add or update the key
  petDetails[detailKey] = detailValue;

  // Save back as a JSON string
  localStorage.setItem("petDetails", JSON.stringify(petDetails));
}
function getPetDetails() {
  try {
    const data = localStorage.getItem("petDetails");
    return data ? JSON.parse(data) : null;
  } catch (error) {
    console.error("Failed to parse petDetails from localStorage", error);
    return null;
  }
}

async function sendKlaviyoRequest(endpoint) {
  const petDetails = getPetDetails();

  if (!petDetails?.email || !petDetails?.name) {
    console.warn("Missing pet details");
    return;
  }

  try {
    await fetch(`${QUIZAPP_URL}/api/klaviyo/${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: petDetails.email,
        pet_name: petDetails.name,
      }),
    });
  } catch (error) {
    console.error(`Klaviyo ${endpoint} request failed`, error);
  }
}

async function sendQuizResultsEmail(email, petDetails, resultData) {
  function formatDisplayValue(value) {
    if (!value) return "-";
    return String(value)
      .replace(/_/g, " ")
      .replace(/\b\w/g, function (l) {
        return l.toUpperCase();
      });
  }

  function formatProductTitle(value) {
    if (!value) return "";
    return String(value)
      .replace(/-/g, " ")
      .replace(/\b\w/g, function (l) {
        return l.toUpperCase();
      });
  }

  function formatListDisplay(list, customValue) {
    var items = (list || []).filter(function (item) {
      return item && item !== "none" && item !== "other";
    });

    if (Array.isArray(list) && list.includes("other") && customValue) {
      items.push(customValue);
    }

    if (!items.length) return "None";

    return items
      .map(function (item) {
        return String(item)
          .replace(/_/g, " ")
          .replace(/\b\w/g, function (l) {
            return l.toUpperCase();
          });
      })
      .join(", ");
  }

  function getProductImageUrl(product) {
    if (!product) return "";

    var firstImage = Array.isArray(product.images) ? product.images[0] : null;
    if (typeof firstImage === "string") return firstImage;
    if (firstImage && firstImage.src) return firstImage.src;

    return product?.image?.src || "";
  }

  var recommendedDryHandle = resultData?.recommendedProductDry || "";
  var recommendedWetHandle = resultData?.recommendedProductWet || "";

  var products = await Promise.all([
    fetchProductInfo(recommendedDryHandle),
    fetchProductInfo(recommendedWetHandle),
  ]);

  var recommendedDryImage = getProductImageUrl(products[0]);
  var recommendedWetImage = getProductImageUrl(products[1]);

  var payload = {
    // email: email,
    pet_name: petDetails?.name || "",
    age: petDetails?.dob || "",
    spayed:
      petDetails?.spayed === "true"
        ? "Yes"
        : petDetails?.spayed === "false"
          ? "No"
          : "-",
    weight: petDetails?.weight ? petDetails.weight + " lbs" : "-",
    breed: petDetails?.breed || "-",
    activity: petDetails?.activity || "-",
    body_type: formatDisplayValue(petDetails?.bodytype),
    health_issues: formatListDisplay(
      petDetails?.healthIssues,
      petDetails?.customHealthIssue,
    ),
    allergies: formatListDisplay(
      petDetails?.allergies,
      petDetails?.customAllergyIssue,
    ),
    feeding_plan: formatDisplayValue(
      resultData?.feedingPlan || petDetails?.feedingPlan,
    ),
    calories_per_day: resultData?.calPerDay
      ? String(resultData.calPerDay)
      : "0",
    cups_dry_per_day: resultData?.cupsPerDayFraction
      ? String(resultData.cupsPerDayFraction)
      : "0",
    cups_wet_per_day: resultData?.cupsPerDayWetFraction
      ? String(resultData.cupsPerDayWetFraction)
      : "0",
    recommended_dry_product: recommendedDryHandle,
    recommended_wet_product: recommendedWetHandle,
    recommended_dry_handle: recommendedDryHandle,
    recommended_wet_handle: recommendedWetHandle,
    recommended_dry_title: formatProductTitle(recommendedDryHandle),
    recommended_wet_title: formatProductTitle(recommendedWetHandle),
    recommended_dry_image: recommendedDryImage,
    recommended_wet_image: recommendedWetImage,
    recommended_recipe_reason: resultData?.recommendedRecipeReason || "",
    recommended_recipe_reason_wet: resultData?.recommendedRecipeReasonWet || "",
    triggerSource: "results_email_button",
  };

  var notRecommendedFoods = (resultData?.notRecomendedFood || []).map(
    function (item) {
      return {
        food: item.food,
        reason: item.reason || "",
      };
    },
  );

  if (notRecommendedFoods.length) {
    payload.not_recommended_foods = notRecommendedFoods;
  }

  const response = await fetch(`${QUIZAPP_URL}/api/klaviyo/email-results`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email: email, properties: payload }),
  });

  let body = null;
  try {
    body = await response.json();
  } catch (error) {
    body = null;
  }

  if (!response.ok || (body && body.success === false)) {
    const errorMessage =
      (body && body.message) ||
      (body && body.error) ||
      "Unable to send results right now. Please try again.";
    throw new Error(errorMessage);
  }

  return body;
}

function klaviyoStartQuiz() {
  sendKlaviyoRequest("startquiz");
}
function klaviyoEndQuiz() {
  sendKlaviyoRequest("profile");
}

async function submitDetails() {
  // Show loading state on page 12
  showpage(12);
  var successEl = document.getElementById("results-success");
  var errorEl = document.getElementById("results-error");
  var apiErrorEl = document.getElementById("results-api-error");
  if (successEl) successEl.style.display = "none";
  if (errorEl) errorEl.style.display = "none";
  if (apiErrorEl) apiErrorEl.style.display = "none";

  // Show spinner
  var loadingEl = document.getElementById("results-loading");
  if (!loadingEl) {
    loadingEl = document.createElement("div");
    loadingEl.id = "results-loading";
    loadingEl.className = "results-loading";
    loadingEl.innerHTML =
      '<div class="results-loading__spinner"></div><p class="results-loading__text">Analyzing your pup\'s profile...</p>';
    document.getElementById("quiz-page-12").appendChild(loadingEl);
  }
  loadingEl.style.display = "flex";

  try {
    await klaviyoEndQuiz();

    const petDetails = getPetDetails();

    const response = await fetch(`${QUIZAPP_URL}/api/pet/food`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(petDetails),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const processedResp = await response.json();

    // Check if the API returned an error
    if (processedResp?.error) {
      loadingEl.style.display = "none";
      // Show API error state
      if (apiErrorEl) {
        apiErrorEl.style.display = "block";
        var apiMessage = apiErrorEl.querySelector(
          ".results-error__api-message",
        );
        if (apiMessage) {
          // Show friendly message instead of technical error
          apiMessage.textContent =
            "We're having trouble connecting to our servers. Please try again in a moment.";
        }
        // Setup API error state buttons
        setupApiErrorButtons();
      }
      return;
    }

    loadingEl.style.display = "none";
    populateResults(processedResp?.data);
  } catch (error) {
    console.log("Error submitting details: ", error);
    loadingEl.style.display = "none";
    // Show API error state on generic failure (network error, etc.)
    if (apiErrorEl) {
      apiErrorEl.style.display = "block";
      var apiMessage = apiErrorEl.querySelector(".results-error__api-message");
      if (apiMessage) {
        apiMessage.textContent =
          "We're having trouble connecting to our servers. Please try again in a moment.";
      }
      // Setup API error state buttons
      setupApiErrorButtons();
    }
  }
}

function setupApiErrorButtons() {
  // Setup Retry button
  var retryBtn = document.getElementById("retry-api-btn");
  if (retryBtn) {
    retryBtn.onclick = function () {
      submitDetails();
    };
  }

  // Setup Edit Quiz button
  var editQuizBtn = document.getElementById("edit-quiz-error-btn");
  if (editQuizBtn) {
    editQuizBtn.onclick = function () {
      showpage(1);
    };
  }
}

function setupErrorButtons() {
  // Setup Edit Allergies button
  var editAllergyBtn = document.getElementById("edit-allergies-btn");
  if (editAllergyBtn) {
    editAllergyBtn.onclick = function () {
      showpage(10);
    };
  }

  // Setup Start Over button
  var startOverBtn = document.getElementById("start-over-btn");
  if (startOverBtn) {
    startOverBtn.onclick = function () {
      localStorage.removeItem("petDetails");
      initializePetDetails();
      location.reload();
    };
  }
}

function populateResults(data) {
  var successEl = document.getElementById("results-success");
  var errorEl = document.getElementById("results-error");
  var petDetails = getPetDetails();
  var petName = petDetails?.name || data?.pet_name || "your pet";

  // Update all pet name spans on results page
  var petNameSpans = document.querySelectorAll(
    "#quiz-page-12 .results-pet-name",
  );
  petNameSpans.forEach(function (el) {
    el.textContent = petName;
  });

  // Determine if we have a valid recommendation
  var hasRecommendation =
    (data?.recommendedProductDry && data.recommendedProductDry !== "") || (data?.recommendedProductWet && data.recommendedProductWet !== "");

  if (!hasRecommendation) {
    // Show Oh Snap error state
    if (successEl) successEl.style.display = "none";
    if (errorEl) errorEl.style.display = "block";

    // Populate allergy list
    var allergyList = errorEl.querySelector(".results-error__allergy-list");
    if (allergyList && petDetails) {
      var allergies = petDetails.allergies || [];
      var customAllergy = petDetails.customAllergyIssue || "";
      var allAllergyNames = allergies
        .filter(function (a) {
          return a !== "none" && a !== "other";
        })
        .map(function (a) {
          return a.replace(/_/g, " ").replace(/\b\w/g, function (l) {
            return l.toUpperCase();
          });
        });
      if (allergies.includes("other") && customAllergy) {
        allAllergyNames.push("Others");
      }
      allergyList.textContent =
        allAllergyNames.join(", ") || "various ingredients";
    }

    // Setup error state buttons
    setupErrorButtons();
    return;
  }

  // ---- SUCCESS STATE ----
  if (errorEl) errorEl.style.display = "none";
  if (successEl) successEl.style.display = "block";

  // Calories
  var calPerDay = data?.calPerDay || "0";
  calPerDay = calPerDay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas to calories number
  document
    .querySelectorAll(".results-cal-per-day, .results-cal-per-day-big")
    .forEach(function (el) {
      el.textContent = calPerDay;
    });

  // Cups - determine based on feeding plan
  var feedingPlan = data?.feedingPlan || petDetails?.feedingPlan || "dry_only";
  var cupsDry = data?.cupsPerDayFraction || "0";
  var cupsWet = data?.cupsPerDayWetFraction || "0";
  cupsDry = normalizeCupDisplayValue(cupsDry);
  cupsWet = normalizeCupDisplayValue(cupsWet);
  var cupsTotal = "";
  var isNotSure = feedingPlan === "Not sure";

  // Toggle default vs not-sure display
  var defaultMealEl = document.getElementById("results-meal-default");
  var notSureMealEl = document.getElementById("results-meal-notsure");

  if (isNotSure) {
    // "Not sure" — show either/or options, hide default stats
    if (defaultMealEl) defaultMealEl.style.display = "none";
    if (notSureMealEl) notSureMealEl.style.display = "block";

    // Populate the not-sure option values
    document
      .querySelectorAll(".results-cups-dry-notsure")
      .forEach(function (el) {
        el.innerHTML = formatFractionWithSmallFont(cupsDry);
      });
    document
      .querySelectorAll(".results-cups-wet-notsure")
      .forEach(function (el) {
        el.innerHTML = formatFractionWithSmallFont(cupsWet);
      });
  } else {
    // Normal feeding plan
    if (defaultMealEl) defaultMealEl.style.display = "block";
    if (notSureMealEl) notSureMealEl.style.display = "none";

    if (feedingPlan === "dry_only") {
      cupsTotal = cupsDry;
      cupsWet = "0";
    } else if (feedingPlan === "wet_only") {
      cupsTotal = cupsWet;
      cupsDry = "0";
    } else {
      // half_half
      // cupsPerDayFraction = dry food portion
      // cupsPerDayWetFraction = wet food portion
      // Calculate total by adding them
      var dryDecimal = parseFractionString(cupsDry);
      var wetDecimal = parseFractionString(cupsWet);
      var totalDecimal = dryDecimal + wetDecimal;

      cupsTotal = convertDecimalToFraction(totalDecimal);
    }

    document
      .querySelectorAll(".results-cups-total, .results-cups-total-big")
      .forEach(function (el) {
        el.innerHTML = formatFractionWithSmallFont(cupsTotal);
      });
    document.querySelectorAll(".results-cups-dry").forEach(function (el) {
      el.innerHTML = formatFractionWithSmallFont(cupsDry);
    });
    document.querySelectorAll(".results-cups-wet").forEach(function (el) {
      el.innerHTML = formatFractionWithSmallFont(cupsWet);
    });
  }

  // Product recommendations
  var productsContainer = document.getElementById("results-products-list");
  if (productsContainer) {
    productsContainer.innerHTML = "";
    var showNotRecommendedRecipes =
      productsContainer.dataset.showNotRecommendedRecipes === "true";

    // Build list of products to show
    var productCards = [];

    // Recommended dry product
    if (data.recommendedProductDry) {
      productCards.push({
        handle: data.recommendedProductDry,
        type: "recommended",
        badgeText: "Recommended Dry Food Recipe",
        reason: data.recommendedRecipeReason || "",
      });
    }

    // Recommended wet product
    if (data.recommendedProductWet) {
      productCards.push({
        handle: data.recommendedProductWet,
        type: "recommended",
        badgeText: "Recommended Wet Food Recipe",
        reason: data.recommendedRecipeReasonWet || "",
      });
    }

    // Not recommended foods
    if (
      showNotRecommendedRecipes &&
      data.notRecomendedFood &&
      data.notRecomendedFood.length > 0
    ) {
      data.notRecomendedFood.forEach(function (item) {
        productCards.push({
          handle: item.food + "-dry-dog-food",
          type: "not-recommended",
          badgeText: "Not Recommended Food",
          reason: item.reason || "",
        });
      });
    }

    // Fetch and render each product card
    var fetchPromises = productCards.map(function (card) {
      return fetchProductInfo(card.handle)
        .then(function (product) {
          card.product = product;
          return card;
        })
        .catch(function () {
          card.product = null;
          return card;
        });
    });

    Promise.all(fetchPromises).then(function (cards) {
      cards.forEach(function (card) {
        var productEl = createProductCard(card);
        if (productEl) productsContainer.appendChild(productEl);
      });
    });
  }

  // Build Summary of Answers
  buildSummaryOfAnswers(petDetails, data);

  // Setup Edit Quiz button
  var editQuizBtn = document.getElementById("edit-quiz-btn");
  if (editQuizBtn) {
    editQuizBtn.onclick = function () {
      showpage(1);
    };
  }

  // Setup email results button
  var emailBtn = document.getElementById("results-email-btn");
  var emailInput = document.getElementById("results-email-input");
  var emailForm = emailInput ? emailInput.parentElement : null;
  var emailStatus = document.getElementById("results-email-status");

  if (!emailStatus && emailForm) {
    emailStatus = document.createElement("p");
    emailStatus.id = "results-email-status";
    emailStatus.className = "results-order__status";
    emailStatus.style.display = "none";
    emailForm.appendChild(emailStatus);
  }

  if (emailInput && petDetails?.email) {
    emailInput.value = petDetails.email;
  }

  if (emailInput && emailBtn) {
    emailInput.style.display = "";
    emailBtn.style.display = "";
    emailBtn.disabled = false;
    emailBtn.textContent = "Email Me Now";
  }

  if (emailStatus) {
    emailStatus.style.display = "none";
    emailStatus.textContent = "";
  }

  if (emailBtn) {
    emailBtn.onclick = async function () {
      var email = emailInput ? emailInput.value.trim() : "";
      if (!email) {
        if (emailStatus) {
          emailStatus.textContent = "Please enter an email address.";
          emailStatus.style.color = "#b42318";
          emailStatus.style.display = "block";
        }
        return;
      }

      if (emailInput && !emailInput.checkValidity()) {
        if (emailStatus) {
          emailStatus.textContent = "Please enter a valid email address.";
          emailStatus.style.color = "#b42318";
          emailStatus.style.display = "block";
        }
        return;
      }

      setPetDetails("email", email);

      if (emailStatus) {
        emailStatus.textContent = "";
        emailStatus.style.display = "none";
      }

      emailBtn.disabled = true;
      var originalBtnText = emailBtn.textContent;
      emailBtn.textContent = "Sending...";

      try {
        await sendQuizResultsEmail(email, getPetDetails(), data);

        if (emailInput) {
          emailInput.style.display = "none";
        }
        emailBtn.style.display = "none";

        if (emailStatus) {
          emailStatus.textContent =
            "Results sent successfully. Please check your inbox.";
          emailStatus.style.color = "#067647";
          emailStatus.style.display = "block";
        }
      } catch (error) {
        console.error("Failed to send quiz results email", error);
        emailBtn.disabled = false;
        emailBtn.textContent = originalBtnText;

        if (emailStatus) {
          emailStatus.textContent =
            error?.message ||
            "Unable to send results right now. Please try again.";
          emailStatus.style.color = "#b42318";
          emailStatus.style.display = "block";
        }
      }
    };
  }
}

function createProductCard(card) {
  var product = card.product;
  var title =
    product?.title ||
    card.handle.replace(/-/g, " ").replace(/\b\w/g, function (l) {
      return l.toUpperCase();
    });
  var image = product?.images?.[0]?.src || product?.image?.src || "";
  var productUrl = product ? "/products/" + card.handle : "#";

  var isNotRecommended = card.type === "not-recommended";
  var borderClass = isNotRecommended ? " results-product--not-recommended" : "";
  var badgeClass = isNotRecommended
    ? "results-product__badge--not-recommended"
    : "results-product__badge--recommended";

  var el = document.createElement("a");
  el.href = productUrl;
  el.className = "results-product" + borderClass;
  el.innerHTML =
    '<span class="results-product__badge ' +
    badgeClass +
    '">' +
    card.badgeText +
    "</span>" +
    '<div class="results-product__image">' +
    (image ? '<img src="' + image + '" alt="' + title + '">' : "") +
    "</div>" +
    '<div class="results-product__details">' +
    '<div class="results-product__rating">' +
    '<div class="results-product__stars">' +
    generateStars(5) +
    "</div>" +
    '<span class="results-product__review-count">100+ Reviews</span>' +
    "</div>" +
    '<h4 class="results-product__name">' +
    title +
    "</h4>" +
    (card.reason
      ? '<p class="results-product__reason">' + card.reason + "</p>"
      : "") +
    "</div>" +
    '<div class="results-product__arrow">' +
    `
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 24H44M44 24L26 6M44 24L26 42" stroke="#212121" stroke-width="4"/>
</svg>

    ` +
    "</div>";

  return el;
}

function generateStars(rating) {
  var html = "";
  for (var i = 1; i <= 5; i++) {
    if (i <= Math.floor(rating)) {
      html += `
      <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.60845 0L9.95959 4.76393L15.2169 5.52786L11.4127 9.23607L12.3107 14.4721L7.60845 12L2.90617 14.4721L3.80423 9.23607L-4.76837e-07 5.52786L5.25731 4.76393L7.60845 0Z" fill="#F28305"/>
      </svg>
      `;
    } else if (i - rating < 1) {
      html +=
        '<svg viewBox="0 0 16 16"><defs><linearGradient id="half-' +
        i +
        '"><stop offset="50%" stop-color="#d4a843"/><stop offset="50%" stop-color="#ddd"/></linearGradient></defs><polygon points="8,1 10.2,5.5 15,6.1 11.5,9.5 12.4,14.2 8,11.8 3.6,14.2 4.5,9.5 1,6.1 5.8,5.5" fill="url(#half-' +
        i +
        ')"/></svg>';
    } else {
      html +=
        '<svg viewBox="0 0 16 16" fill="#ddd"><polygon points="8,1 10.2,5.5 15,6.1 11.5,9.5 12.4,14.2 8,11.8 3.6,14.2 4.5,9.5 1,6.1 5.8,5.5"/></svg>';
    }
  }
  return html;
}

function buildSummaryOfAnswers(petDetails, data) {
  var container = document.getElementById("results-summary-rows");
  if (!container || !petDetails) return;

  container.innerHTML = "";

  var rows = [
    { label: "Name", value: petDetails.name || "-" },
    { label: "Age", value: petDetails.dob || "-" },
    {
      label: "Spayed / Neutered",
      value:
        petDetails.spayed === "true"
          ? "Yes"
          : petDetails.spayed === "false"
            ? "No"
            : "-",
    },
    {
      label: "Weight",
      value: petDetails.weight ? petDetails.weight + " Lbs" : "-",
    },
    { label: "Breed", value: petDetails.breed || "-" },
    { label: "Activity", value: petDetails.activity || "-" },
    {
      label: "Body type",
      value: petDetails.bodytype
        ? petDetails.bodytype.replace(/_/g, " ").replace(/\b\w/g, function (l) {
            return l.toUpperCase();
          })
        : "-",
    },
    {
      label: "Feeding Plan",
      value: data?.feedingPlan
        ? data.feedingPlan.replace(/_/g, " ").replace(/\b\w/g, function (l) {
            return l.toUpperCase();
          })
        : "-",
    },
    {
      label: "Health issues",
      value: formatListValue(
        petDetails.healthIssues,
        petDetails.customHealthIssue,
      ),
    },
    {
      label: "Allergies/Sensitivities",
      value: formatListValue(
        petDetails.allergies,
        petDetails.customAllergyIssue,
      ),
    },
  ];

  rows.forEach(function (row) {
    var rowEl = document.createElement("div");
    rowEl.className = "results-summary__row";
    rowEl.innerHTML =
      '<span class="results-summary__row-label">' +
      row.label +
      "</span>" +
      '<span class="results-summary__row-value">' +
      row.value +
      "</span>";
    container.appendChild(rowEl);
  });
}

function formatListValue(arr, customValue) {
  if (!arr || arr.length === 0) return "-";
  var items = arr
    .filter(function (a) {
      return a !== "none" && a !== "other";
    })
    .map(function (a) {
      return a
        .replace(/_/g, " ")
        .replace(/&/g, " & ")
        .replace(/\b\w/g, function (l) {
          return l.toUpperCase();
        });
    });
  if (arr.includes("other") && customValue) items.push(customValue);
  return items.length > 0 ? items.join(", ") : "None";
}

function normalizeCupDisplayValue(value) {
  if (value === null || value === undefined) return "0";

  var str = String(value).trim();
  if (!str) return "0";

  // Mixed numbers, e.g. "06 1/8" -> "6 1/8"
  var mixedMatch = str.match(/^(\d+)\s+(\d+)\/(\d+)$/);
  if (mixedMatch) {
    var whole = String(parseInt(mixedMatch[1], 10));
    var num = String(parseInt(mixedMatch[2], 10));
    var den = String(parseInt(mixedMatch[3], 10));
    return whole + " " + num + "/" + den;
  }

  // Fractions, e.g. "03/08" -> "3/8"
  var fractionMatch = str.match(/^(\d+)\/(\d+)$/);
  if (fractionMatch) {
    var numerator = String(parseInt(fractionMatch[1], 10));
    var denominator = String(parseInt(fractionMatch[2], 10));
    return numerator + "/" + denominator;
  }

  // Whole integers, e.g. "06" -> "6"
  if (/^\d+$/.test(str)) {
    return String(parseInt(str, 10));
  }

  return str;
}

function formatFractionWithSmallFont(str) {
  if (!str) return "0";

  str = str.toString();

  // Check if it contains a space and forward slash (mixed number like "6 1/2")
  if (str.includes(" ") && str.includes("/")) {
    const parts = str.split(" ");
    const whole = parts[0];
    const fraction = parts[1];
    return `${whole} <span style="font-size: 0.7em;">${fraction}</span>`;
  }

  // Check if it's just a fraction (like "1/2")
  if (str.includes("/")) {
    return `<span style="font-size: 0.7em;">${str}</span>`;
  }

  // Just a whole number
  return str;
}

function parseFractionString(str) {
  if (!str || str === "0" || str === 0) return 0;

  // Convert to string if it's a number
  str = str.toString().trim();

  // Check if it's a mixed number (e.g., "2 1/2")
  if (str.includes(" ") && str.includes("/")) {
    const parts = str.split(" ");
    const whole = parseFloat(parts[0]) || 0;
    const fractionParts = parts[1].split("/");
    const numerator = parseFloat(fractionParts[0]) || 0;
    const denominator = parseFloat(fractionParts[1]) || 1;
    return whole + numerator / denominator;
  }

  // Check if it's just a fraction (e.g., "1/2")
  if (str.includes("/")) {
    const fractionParts = str.split("/");
    const numerator = parseFloat(fractionParts[0]) || 0;
    const denominator = parseFloat(fractionParts[1]) || 1;
    return numerator / denominator;
  }

  // Otherwise, it's just a number
  return parseFloat(str) || 0;
}

function convertDecimalToFraction(valu) {
  if (valu === 0 || valu === undefined || valu === null) return "0";

  const decimal = valu - Math.floor(valu);
  const whole = Math.floor(valu);
  const numerator = decimal * 8;
  const denominator = 8;

  if (numerator == 0) {
    return whole.toString();
  } else {
    //check if fraction can be reduced

    const gcd = (a, b) => {
      if (b < 0.0000001) return a;
      return gcd(b, Math.floor(a % b));
    };

    const divisor = gcd(numerator, denominator);

    const num = numerator / divisor;
    const den = denominator / divisor;

    if (den == 1) {
      return `${whole + num}`;
    }

    if (whole == 0) {
      return `${num}/${den}`;
    }

    return `${whole} ${num}/${den}`;
  }
}

function fetchProductInfo(productHandle) {
  if (!productHandle) return Promise.resolve(null);
  return fetch("/products/" + productHandle + ".json")
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data.product;
    })
    .catch(function (error) {
      console.error("Error fetching product info:", error);
      return null;
    });
}
